import moment from "moment-timezone";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { revenueRepEndDate, revenueRepStartDate } from "functionCall";
import { baseURL } from "../../config/index";
import { format } from "date-fns";
import { Placeholder } from "react-bootstrap";
import dayjs from "dayjs";
import { groupBy, compact, filter } from "lodash";
import { CDN_BASE_URL } from "../../config/env";
import { getDefaultRouteForRole } from "../../config/routeComponentRegistry";
// import Dr_Sonal_Makhija from "../../assets/img/doctor/sonal_makhija.png";
// import Dr_Shreya_Deoghare from "../../assets/img/doctor/shreya_deoghere.png";
// import Dr_Divya_Poulose from "../../assets/img/doctor/Divya_poulose.png";
// import Dr_Vandana_Verma from "../../assets/img/doctor/vandana_verma.png";
// import Dr_Sonia_Tekchandani from "../../assets/img/doctor/sonia_tekchandini.png";
// import Dr_Shefali_Saini from "../../assets/img/doctor/Shefali_Saini.png";
// import Dr_Siddhi_Sonawane from "../../assets/img/doctor/siddhi_sonawane.png";
// import Dr_Harish_Balaji from "../../assets/img/doctor/harish_balaji.png";
// import Dr_Kalyani_Deshmukh from "../../assets/img/doctor/kalyani_deshmukh.png";
// import Dr_Dhwani_Saxena from "../../assets/img/doctor/Dhwani_Saxena.png";
// import Dr_Aakanksha_Gupta from "../../assets/img/doctor/aakansha_gupta.png";
// import Dr_Shailendra from "../../assets/img/doctor/Shailendra_Chaubey.png";
// import Dr_Rashi_Soni from "../../assets/img/doctor/rashi_soni.png";
// import Dr_Aarushi_Mittal from "../../assets/img/doctor/aarushi_mittal.png";
// import Dr_Shweta_Tripathi from "../../assets/img/doctor/shweta_tripati.png";
// import Dr_Komal_Rathi from "../../assets/img/doctor/Komal_Rathi.png";
// import Dr_Pawan_singh from "../../assets/img/doctor/Pawan_singh.png";
// import divya_shree from "../../assets/img/doctor/divya_shree.png";
// import divyesh_jain from "../../assets/img/doctor/divyesh_jain.png";
// import Ramoli_Nimbalkar from "../../assets/img/doctor/Ramoli_Nimbalkar.png";
// import harshal_petkar from "../../assets/img/doctor/harshal_petkar.png";
// import jsesica from "../../assets/img/doctor/jsesica.png";
// import Dr_Reena_Majithia from "../../assets/img/doctor/Dr_Reena_Majithia.png";
// import Dr_Avtarsinh_Vaghela from "../../assets/img/doctor/Dr_Avtarsinh_Vaghela.png";
// import Dr_Vijayalaxmi from "../../assets/img/doctor/Dr_Vijayalaxmi.png";
// import shriya from "../../assets/img/doctor/shriya.png";
// import Dr_Ritu from "../../assets/img/doctor/Dr_Ritu.png";
// import Dr_Rajpal from "../../assets/img/doctor/Dr_Raj_Pal.png";
// import Dr_shama_naaz from "../../assets/img/doctor/Dr_shama_naaz.png";
// import Dr_Kreeti from "../../assets/img/doctor/Dr_Kreeti_Shankar.png";
// import Dr_Deepak from "../../assets/img/doctor/Dr_Deepak.png";
// import Dr_Asna_Hassan from "../../assets/img/doctor/Dr_Asna_Hassan.png";
// import Dr_Chintaman_Suvarna from "../../assets/img/doctor/Dr_Chintaman_Suvarna.png";
// import Dr_Nandini_Shetty from "../../assets/img/doctor/Dr_Nandini_Shetty.png";
// import Dr_Haarika_Sadhu from "../../assets/img/doctor/Dr_Haarika_Sadhu.png";
// import Dr_Sukrutha from "../../assets/img/doctor/Dr_Sukrutha.png";
// import Dr_Manali from "../../assets/img/doctor/Dr_Manali.png";
// import Dr_Manish from "../../assets/img/doctor/Dr_Manish.png";
// import Dr_Mariya from "../../assets/img/doctor/Dr_mariya.png";
// import Dr_sidhi from "../../assets/img/doctor/Dr_sidhi.png";
// import Dr_Ketaki from "../../assets/img/doctor/Dr_Ketaki.png";
// import Dr_Darshana_Kulkarni from  "../../assets/img/doctor/Dr_Darshana_Kulkarni.png";
// import Dr_Afreen_Sayyed from "../../assets/img/doctor/Dr_Afreen_Sayyed.png";
// import Dr_Oshin_Rajeev from "../../assets/img/doctor/Dr_Oshin_Rajeev.png";
// import Dr_Aisha_Parveen from "../../assets/img/doctor/Dr_Aisha_Parveen.png";
// import Dr_Deepika_Jain from '../../assets/img/doctor/Dr_Deepika_Jain.png';
// import Dr_Sharan_Keshetty from '../../assets/img/doctor/Dr_Sharan_Keshetty.png';
// import Dr_Shashank_Dhatwalia from '../../assets/img/doctor/Dr_Shashank_Dhatwalia.png';
// import Dr_Shivani_Dawas from '../../assets/img/doctor/Dr_Shivani_Dawas.png';
// import Dr_Suhasini_Goyal from '../../assets/img/doctor/Dr_Suhasini_Goyal.png';
// import Dr_Swapnil_Hippargi from '../../assets/img/doctor/Dr_Swapnil_Hippargi.png';
// import Dr_Atul_Soni from '../../assets/img/doctor/Dr_Atul_Soni.png';
// import Dr_Minakshi_Bisen from '../../assets/img/doctor/Dr_Minakshi_Bisen.png';
// import Dr_Deepali_Rai from '../../assets/img/doctor/Dr_Deepali_Rai.png';
// import Dr_Devyani_Baunthiyal from '../../assets/img/doctor/Dr_Devyani_Baunthiyal.png';
// import Dr_Jaineet_Dhillon from '../../assets/img/doctor/Dr_Jaineet_Dhillon.png';
// import Dr_Pratima_Majgaonkar from '../../assets/img/doctor/Dr_Pratima_Majgaonkar.png';
// import Dr_Sakshi from '../../assets/img/doctor/Dr_Sakshi.png';
// import Dr_Vishali_Vasu from '../../assets/img/doctor/Dr_Vishali_Vasu.png';
// import Dr_Anamika_Thakur from '../../assets/img/doctor/Dr_Anamika_Thakur.png';
// import Dr_Dhriti_Sood from '../../assets/img/doctor/Dr_Dhriti_Sood.png';
// import Dr_Lakshmi_Somu from  '../../assets/img/doctor/Dr_Lakshmi_Somu.png';
// import Dr_Priyanka_Soni from '../../assets/img/doctor/Dr_Priyanka_Soni.png';
// import Dr_Sushmita_Singh from '../../assets/img/doctor/Dr_Sushmita_Singh.png';
// import Dr_Yashvi_Doshi from '../../assets/img/doctor/Dr_Yashvi_Doshi.png';
// import Dr_Aayushi from '../../assets/img/doctor/Dr_Aayushi_Wasnik.png';
// import Dr_Aditi from '../../assets/img/doctor/Dr_Aditi_Singh_Baghel.png';
// import Dr_Kishan from '../../assets/img/doctor/Dr_Kishan_Raghuvanshi.png';
// import Dr_Mehak from '../../assets/img/doctor/Dr_Mehak.png';
// import Dr_Pavan from '../../assets/img/doctor/Dr_Pavan_Medidi.png';
// import Dr_Pranjali from '../../assets/img/doctor/Dr_Pranjali_Pradeep_Jagtap.png';
// import Dr_Sasi from '../../assets/img/doctor/Dr_Sasi_Rekha.png';
// import Dr_Tanmay_Badlawala  from '../../assets/img/doctor/Dr_Tanmay_Badlawala.png';
// import Dr_Anshita_Mishra from '../../assets/img/doctor/Dr_Anshita_Mishra.png';
// import Dr_Mahima_Chaudhary from '../../assets/img/doctor/Dr_Mahima_Chaudhary.png';
// import Dr_Shreya_Rawat from '../../assets/img/doctor/Dr_Shreya_Rawat.png';
// import Dr_Shiv_Singh_Shekhawat from '../../assets/img/doctor/Dr_Shiv_Singh_Shekhawat.png';
// import Dr_Amaan_Kapadia from '../../assets/img/doctor/Dr_Amaan_Kapadia.png';
// import Dr_Aryan_Babbar from '../../assets/img/doctor/Dr_Aryan_Babbar.png';
// import Dr_Anshika_Verma from '../../assets/img/doctor/Dr_Anshika_Verma.png';
// import Dr_Madhuri_Prasad from '../../assets/img/doctor/Dr_Madhuri_Prasad.png';
// import Dr_Siddhi_Bhartiya from '../../assets/img/doctor/Dr_Siddhi_Bhartiya.png';
// import Dr_Yash_Choudhary from '../../assets/img/doctor/Dr_Yash_Choudhary.png';
// import Dr_Snehal_Devendra_Yadav from '../../assets/img/doctor/Dr_Snehal_Devendra_Yadav.png';
// import Dr_Astha_Pathak from '../../assets/img/doctor/Dr_Astha_Pathak.png';
// import Dr_Alisha from '../../assets/img/doctor/Dr_Alisha.png';
// import Dr_Shikhar from '../../assets/img/doctor/Dr_Shikhar.png';
// import Dr_Ankita_Shukla from '../../assets/img/doctor/Dr_Ankita_Shukla.png';
// import Dr_Sanjay_Kumar from '../../assets/img/doctor/Dr_Sanjay_Kumar.png';
// import Dr_Prachi from '../../assets/img/doctor/Dr_Prachi.png';
// import Dr_Vidhya from '../../assets/img/doctor/Dr_Vidhya.png';
// import Dr_Srinidhi_Udayakumar from '../../assets/img/doctor/Dr_Srinidhi_Udayakumar.png';
// import Dr_Manish_Raja from '../../assets/img/doctor/Dr_Manish_Raja.png';
// import Dr_Nikita_Manocha from '../../assets/img/doctor/Dr_Nikita_Manocha.png';
// import Dr_Anisha_Chauhan from '../../assets/img/doctor/Dr_Anisha_Chauhan.png';
// import Dr_Sabir_Vasim_Zariwala from '../../assets/img/doctor/Dr_Sabir_Vasim_Zariwala.png';
// import Dr_Prerna_Giri from '../../assets/img/doctor/Dr_Prerna_Giri.png';
// import Dr_Shobha_Gupta from '../../assets/img/doctor/Dr_Shobha_Gupta.png';
// import Dr_Srividhya_Madira from '../../assets/img/doctor/Dr_Srividhya_Madira.png';
// import Dr_Swati_Kaushal from '../../assets/img/doctor/Dr_Swati_Kaushal.png';
// import Dr_Shiladitya_Giri from '../../assets/img/doctor/Dr_Shiladitya_Giri.png';
// import Dr_Bagmita_Mishra from '../../assets/img/doctor/Dr_Bagmita_Mishra.png';
// import Dr_Khushi_Jeswani from '../../assets/img/doctor/Dr_Khushi_Jeswani.png';
// import Dr_Aswathy_R from '../../assets/img/doctor/Dr_Aswathy_R.png';
// import Dr_Manpreet_Singh from '../../assets/img/doctor/Dr_Manpreet_Singh.png';
// import Dr_Pooja_Patel from '../../assets/img/doctor/Dr_Pooja_Patel.png';
// import Dr_Gaurav_Raj from '../../assets/img/doctor/Dr_Gaurav_Raj.png';
// import Dr_Manisha_Sharma from '../../assets/img/doctor/Dr_Manisha_Sharma.png';
// import Dr_Itika_Sharma from '../../assets/img/doctor/Dr_Ikita_Sharma.png';
// import Dr_Muralii_Krishna from '../../assets/img/doctor/Dr_Muralii_Krishna.png';
// import Dr_Puja_Chaudhari from '../../assets/img/doctor/Dr_Puja_Chaudhari.png';
// import Dr_Shubham_Sehrawat from '../../assets/img/doctor/Dr_Shubham_Sehrawat.png';
// import Dr_Noopur_Chauhan from '../../assets/img/doctor/Dr_Noopur_Chauhan.png';
// import Dr_Sachita_Bhaskar from '../../assets/img/doctor/Dr_Sachita_Bhaskar.png';
// import Dr_Shehraz_Pasha from '../../assets/img/doctor/Dr_Shehraz_Pasha.png';
// import Dr_Shifa_Kausar from '../../assets/img/doctor/Dr_Shifa_Kausar.png';
// import Dr_Mehak_Aggarwal from '../../assets/img/doctor/Dr_Mehak_Aggarwal.png';
// import Dr_Monika_Kanwar from '../../assets/img/doctor/Dr_Monika_Kanwar.png';
// import Dr_Paul_MelkiSedhek from '../../assets/img/doctor/Dr_Paul_MelkiSedhek.png';
// import Dr_Ankita_Bandgar from '../../assets/img/doctor/Dr_Ankita_Bandgar.png';
// import Dr_Deepa_Boloor from '../../assets/img/doctor/Dr_Deepa_Boloor.png';
// import Dr_Anushka_Rao  from '../../assets/img/doctor/Dr_Anushka_Rao.png';
// import Dr_Rugved_Dudhat from '../../assets/img/doctor/Dr_Rugved_Dudhat.png';
// import Dr_Ankita_Patil from '../../assets/img/doctor/Dr_Ankita_Patil.png';
// import Dr_Dhwani_Dipenkumar_Maniar from '../../assets/img/doctor/Dr_Dhwani_Dipenkumar_Maniar.png';
// import Dr_Yogita_Arya from '../../assets/img/doctor/Dr_Yogita_Arya.png';
// import Dr_Sakshi_Omar from '../../assets/img/doctor/Dr_Sakshi_Omar.png';
// import Dr_Vishakha_Sharma from '../../assets/img/doctor/Dr_Vishakha_Sharma.png';
// import Dr_Rakshita_Rathore from '../../assets/img/doctor/Dr_Rakshita_Rathore.png';
// import Dr_Aditi_Gupta from '../../assets/img/doctor/Dr_Aditi_Gupta.png';
// import Dr_Sakshi_Singh from '../../assets/img/doctor/Dr_Sakshi_Singh.png';
// import Dr_Darshan_Khosare from '../../assets/img/doctor/Dr_Darshan_Khosare.png';
// import Dr_Sanchit_Sharma from '../../assets/img/doctor/Dr_Sanchit_Sharma.png';
// import Dr_Dhwani_Haria from '../../assets/img/doctor/Dr_Dhwani_Haria.png';
// import Dr_Sauda_Anjum from '../../assets/img/doctor/Dr_Sauda_Anjum.png';
// import Dr_Diksha_Rani from '../../assets/img/doctor/Dr_Diksha_Rani.png';
// import Dr_Tanushree_KN from '../../assets/img/doctor/Dr_Tanushree_KN.png';
// import Dr_Kriti_Paul from '../../assets/img/doctor/Dr_Kriti_Paul.png';
// import Dr_Utkarsh_Hatwar from '../../assets/img/doctor/Dr_Utkarsh_Hatwar.png';
// import Dr_Lipsa_Patel from '../../assets/img/doctor/Dr_Lipsa_Patel.png';
// import Dr_Vaishnavi_Adiga from '../../assets/img/doctor/Dr_Vaishnavi_Adiga.png';
// import Dr_Malasa_Nayak from '../../assets/img/doctor/Dr_Malasa_Nayak.png';
// import Dr_Vrinda_Sharma from '../../assets/img/doctor/Dr_Vrinda_Sharma.png';
// import Dr_Pritish_Katara from '../../assets/img/doctor/Dr_Pritish_Katara.png';
// import Dr_Yashwanth_Vodapalli from '../../assets/img/doctor/Dr_Yashwanth_Vodapalli.png';
// import Dr_Shrutika from '../../assets/img/doctor/Dr_Shrutika.png';
// import Dr_Shreya_Raj from '../../assets/img/doctor/Dr_Shreya_Raj.png';
// import Dr_Diksha_Sikariya from '../../assets/img/doctor/Dr_Diksha_Sikariya.png';
// import Dr_Mansi_Vikhe from '../../assets/img/doctor/Dr_Mansi_Vikhe.png';
// import Dr_Garvit_Kadian from '../../assets/img/doctor/Dr_Garvit_Kadian.png';
// import Dr_Shivangi_Jaiswal from '../../assets/img/doctor/Dr_Shivangi_Jaiswal.png';
// import Dr_Ayush_Bansal from '../../assets/img/doctor/Dr_Ayush_Bansal.png';
// import Dr_Bushra_Aziz from '../../assets/img/doctor/Dr_Bushra_Aziz.png';
// import Dr_Maitri_Pathak from '../../assets/img/doctor/Dr_Maitri_Pathak.png';
// import Dr_Bhumika_Gupta from '../../assets/img/doctor/Dr_Bhumika_Gupta.png';
// import Dr_Vaishnavi_Bodhe from '../../assets/img/doctor/Dr_Vaishnavi_Bodhe.png';
// import Dr_Vaishnavi_Barde from '../../assets/img/doctor/Dr_Vaishnavi_Barde.png';
// import Dr_Prachi_Sinha from '../../assets/img/doctor/Dr_Prachi_Sinha.png';
// import Dr_Chhavi_Soni from '../../assets/img/doctor/Dr_Chhavi_Soni.png';
// import Dr_Samriti_Soni from '../../assets/img/doctor/Dr_Samriti_Soni.png';
// import Dr_Anjali_Tewari from '../../assets/img/doctor/Dr_Anjali_Tewari.png';
// import Dr_Ayushi_Verma from '../../assets/img/doctor/Dr_Ayushi_Verma.png';
// import Dr_Sourabh_Prashar from '../../assets/img/doctor/Dr_Sourabh_Prashar.png';
// import Dr_Akanksha_Dhadich from '../../assets/img/doctor/Dr_Akanksha_Dhadich.png';
// import Dr_Pragati_Panwar from '../../assets/img/doctor/Dr_Pragati_Panwar.png';
// import Dr_Tanya_Kalra from '../../assets/img/doctor/Dr_Tanya_Kalra.png';
// import Dr_Asritha_Reddy from '../../assets/img/doctor/Dr_Asritha_Reddy.png';
// import Dr_Ankita_Rahulkar from '../../assets/img/doctor/Dr_Ankita_Rahulkar.png';
// import Dr_Anuj_Nautiyal from '../../assets/img/doctor/Dr_Anuj_Nautiyal.png';
// import Dr_Sana_Peerzade from '../../assets/img/doctor/Dr_Sana_Peerzade.png';
// import Dr_Diksha_Shrivastava from '../../assets/img/doctor/Dr_Diksha_Shrivastava.png';
// import Dr_Srushti_Wankhede from '../../assets/img/doctor/Dr_Srushti_Wankhede.png';
// import Dr_Stuti_Chandel from '../../assets/img/doctor/Dr_Stuti_Chandel.png';
// import Dr_Archie_Rawat from '../../assets/img/doctor/Dr_Archie_Rawat.png';
// import Dr_Shivangi_Patel from '../../assets/img/doctor/Dr_Shivangi_Patel.png';
// import Dr_Vikisa_Sharma from '../../assets/img/doctor/Dr_Vikisa_Sharma.png';
// import Dr_Akanksha_Sharma from '../../assets/img/doctor/Dr_Akanksha_Sharma.png';
// import Dr_Akansha_Chauhan from '../../assets/img/doctor/Dr_Akansha_Chauhan.png';
// import Dr_Anushree_Valasang from '../../assets/img/doctor/Dr_Anushree_Valasang.png';
// import Dr_Lakshmi_PG from '../../assets/img/doctor/Dr_Lakshmi_PG.png';
// import Dr_Parvathy_S from '../../assets/img/doctor/Dr_Parvathy_S.png';
// import Dr_Shruti_Rai from '../../assets/img/doctor/Dr_Shruti_Rai.png';
// import Dr_Tejashree from '../../assets/img/doctor/Dr_Tejashree.png';
// import Dr_Chinmay_Verma from '../../assets/img/doctor/Dr_Chinmay_Verma.png'
// import Dr_Mihika_Bawankar from '../../assets/img/doctor/Dr_Mihika_Bawankar.png'
// import Dr_Nidhi_Kaushik from '../../assets/img/doctor/Dr_Nidhi_Kaushik.png'
// import Dr_Shreyashee_Saha from '../../assets/img/doctor/Dr_Shreyashee_Saha.png'
// import Dr_Stuti_Kamdar from '../../assets/img/doctor/Dr_Stuti_Kamdar.png'
// import Dr_Vaidehi_Thakur from '../../assets/img/doctor/Dr_Vaidehi_Thakur.png'
// import Dr_Aakanksha_Pandey from '../../assets/img/doctor/Dr_Aakanksha_Pandey.png'
// import Dr_Anjaly_KR from '../../assets/img/doctor/Dr_Anjaly_KR.png'
// import Dr_Asmi_Sebastian from '../../assets/img/doctor/Dr_Asmi_Sebastian.png'
// import Dr_Priyanka_R_Shastry from '../../assets/img/doctor/Dr_Priyanka_R_Shastry.png'
// import Dr_Soujanya_Kulakarni from '../../assets/img/doctor/Dr_Soujanya_Kulakarni.png'
// import Dr_Chinmaiyee_Bharadwaj from '../../assets/img/doctor/Dr_Chinmaiyee_Bharadwaj.png'
// import Dr_Nidiginti_Thrinayani from '../../assets/img/doctor/Dr_Nidiginti_Thrinayani.png'
// import Dr_Ashna_Jain from '../../assets/img/doctor/Dr_Ashna_Jain.png'
// import Dr_Reena_Lendi from '../../assets/img/doctor/Dr_Reena_Lendi.png'
// import Dr_Yashita_Singh from '../../assets/img/doctor/Dr_Yashita_Singh.png'
// import Dr_Sahana_K from '../../assets/img/doctor/Dr_Sahana_K.png'
// import Dr_Stuti_Jakhmola from '../../assets/img/doctor/Dr_Stuti_Jakhmola.png'
// import Dr_Vartika_Khirwal from '../../assets/img/doctor/Dr_Vartika_Khirwal.png'
// import Dr_Deeksha_Mishra from '../../assets/img/doctor/Dr_Deeksha_Mishra.png'
import xlsx from "json-as-xlsx";
import { voitekkUserIdMap } from "./voitekkUSerIdMap";
import secureLocalStorage from "react-secure-storage";
import { CATEGORY } from 'modules/my_tickets/data';
import { size } from "lodash";
import CryptoJS from 'crypto-js';
import { getStoreList } from "modules/clinic-management/api";
import { getRefundStatusData } from "modules/dashboards/actionables/api";
import { toast } from "react-toastify";

export const getFormattedDate = (date) => {
  return date ? moment(date).format("MMM DD YYYY, hh:mm A") : null;
};

export const getCurrentUserRole = () => {
  const roleId = secureLocalStorage.getItem("role");
  return roles[roleId];
};

export function getFormattedStartDate() {
  const currentDate = new Date();

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}

export function getFormattedEndDate(daysAgo) {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - daysAgo);

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}
// end
export const fetchDataForTab = (
  activeTab,
  urlStartDate,
  urlEndDate,
  todayFlag,
  fetchDataFunction
) => {
  let queryParams;

  if (todayFlag !== 0) {
    queryParams = "&type=today";
    const start = moment().tz("Asia/Kolkata").startOf("day").valueOf();
    const end = moment().tz("Asia/Kolkata").endOf("day").valueOf();
    fetchDataFunction(start, end, queryParams);
  } else {
    const parsedStart = moment(urlStartDate);
    const parsedEnd = moment(urlEndDate);
    const start = parsedStart.isValid() ? parsedStart.startOf("day").valueOf() : moment().tz("Asia/Kolkata").startOf("day").valueOf();
    const end = parsedEnd.isValid() ? parsedEnd.endOf("day").valueOf() : moment().tz("Asia/Kolkata").endOf("day").valueOf();
    fetchDataFunction(start, end, queryParams);
  }
};

export const urlDate = (dateString, turn) => {
  const date = new Date(dateString);
  if (turn === "start") date.setHours(0, 0, 0, 0);
  else date.setHours(23, 59, 59, 0);
  const options = {
    weekday: "short",
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "Asia/Kolkata",
  };

  const formattedDate = date
    .toLocaleString("en-US", options)
    .replace(/,/g, "")
    .replace(/ /g, "+")
    .replace(/:/g, "%3A");

  return formattedDate + `+GMT%2B0530`;
};

export const todaysStartDate = () => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);

  const options = {
    weekday: "short",
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "Asia/Kolkata",
  };

  const formattedDate = date
    .toLocaleString("en-US", options)
    .replace(/,/g, "")
    .replace(/ /g, "+")
    .replace(/:/g, "%3A");

  return formattedDate + `+GMT%2B0530`;
};

export const todaysEndDate = () => {
  const date = new Date();
  date.setHours(23, 59, 59, 0);

  const options = {
    weekday: "short",
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "Asia/Kolkata",
  };

  const formattedDate = date
    .toLocaleString("en-US", options)
    .replace(/,/g, "")
    .replace(/ /g, "+")
    .replace(/:/g, "%3A");

  return formattedDate + `+GMT%2B0530`;
};

export const get24HoursAgoTimeStamp = () => {
  const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);
  twentyFourHoursAgo.setDate(twentyFourHoursAgo.getDate() - 1); // Subtract 1 day

  const timestamp = twentyFourHoursAgo.toISOString().replace(/:/g, "%3A");
  return timestamp;
};

export const getFutureTimestamp = () => {
  const now = new Date();
  const currentDate = now.toISOString().split("T")[0];
  const currentTimestamp =
    currentDate.replace(/-/g, "%2D") +
    "T" +
    now.toISOString().split("T")[1].replace(/[:-]/g, "%3A");
  return currentTimestamp;
};

export const addCurrentTimeToDate = (date) => {
  const currentDate = new Date();
  const hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const seconds = currentDate.getSeconds();
  const milliseconds = currentDate.getMilliseconds();

  const parts = date.split("-");
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);

  const newDate = new Date(year, month, day);
  newDate.setHours(hours);
  newDate.setMinutes(minutes);
  newDate.setSeconds(seconds);
  newDate.setMilliseconds(milliseconds);

  return newDate.toISOString();
};

export function snakeCaseToCapitalizedWords(str) {
  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const ordersValueFn = (orders) => {
  if (!Array.isArray(orders)) return 0.0;
  return orders.reduce((acc, curr) => {
    if (curr.order_meta && curr.order_meta.total_price) {
      acc = acc + Number(curr.order_meta.total_price);
    }
    return acc;
  }, 0.0);
};

export const repeatOrdersFn = (orders) => {
  if (!Array.isArray(orders)) return [];
  return orders.filter((order) => order.status !== "void" && order.count > 1);
};
export const inprogressOrdersFn = (orders) => {
  const default_data = {
    new: 0,
    repeat: 0,
  };

  if (!Array.isArray(orders)) return default_data;

  const inprogressOrders = orders.filter(
    (item) => item.status === "in_progress"
  );
  return inprogressOrders.reduce((acc, curr) => {
    if (curr.count === 1) acc["new"] = acc.new + 1;
    else if (curr.count > 1) acc["repeat"] = acc.repeat + 1;
    return acc;
  }, default_data);
};

export const engagementSummaryFn = (data) => {
  const default_data = {
    percentage: 0.0,
    total: 0,
  };

  if (!Array.isArray(data)) return default_data;
  if (data.length <= 0) return default_data;

  const _finished = data.reduce((acc, curr) => {
    if (curr.is_finished) return (acc = acc + 1);
    return acc;
  }, 0);

  const total = data.length;
  const _percentage = parseFloat((_finished / total) * 100).toFixed(2);

  return {
    percentage: isNaN(_percentage) ? 0.0 : _percentage,
    total,
  };
};

export const homeRoute = () => {
  try {
    const storedObj = secureLocalStorage.getItem("obj");
    const userObj = typeof storedObj === 'string' ? JSON.parse(storedObj) : storedObj;
    const routePermissions = userObj?.routePermissions;

    // 1. Explicit default route configured via RBAC UI
    if (routePermissions?.__settings?.defaultRoute) {
      return routePermissions.__settings.defaultRoute;
    }

    // 2. Derive from first visible navigation item in permissions
    if (routePermissions && typeof routePermissions === 'object') {
      const firstRoute = _getFirstVisibleRoute(routePermissions);
      if (firstRoute) return firstRoute;
    }
  } catch (e) {
    // Fallback to hardcoded routes below
  }

  const role = getCurrentUserRole();
  return getDefaultRouteForRole(role) || "/dashboard?tab=home";
};

/**
 * Derive the first visible route from routePermissions.
 * Picks the lowest-order non-hidden allowed group → its first route →
 * if subroutes → first allowed subroute path
 * if tabs → route path + ?tab=<first-tab-key>
 * else → route path
 */
const _getFirstVisibleRoute = (perms) => {
  const groups = Object.entries(perms)
    .filter(([key, g]) => key !== '__settings' && g && g.routes && !g.hidden && g.allowed !== false)
    .sort((a, b) => (a[1].order ?? Infinity) - (b[1].order ?? Infinity));

  for (const [, group] of groups) {
    const routes = Object.values(group.routes)
      .filter(r => r.allowed !== false)
      .sort((a, b) => (a.order ?? Infinity) - (b.order ?? Infinity));

    for (const route of routes) {
      // Subroutes take priority
      if (route.subRoutes && typeof route.subRoutes === 'object') {
        const subs = Object.values(route.subRoutes)
          .filter(s => s.allowed !== false && s.path)
          .sort((a, b) => (a.order ?? Infinity) - (b.order ?? Infinity));
        if (subs.length > 0) return subs[0].path.toLowerCase();
      }

      // Tabs — append ?tab=<key>
      if (route.tabs && typeof route.tabs === 'object') {
        const tabs = Object.entries(route.tabs)
          .filter(([, t]) => t.allowed !== false)
          .sort((a, b) => (a[1].order ?? Infinity) - (b[1].order ?? Infinity));
        if (tabs.length > 0) return `${(route.path || '').toLowerCase()}?tab=${tabs[0][0]}`;
      }

      // Leaf route
      if (route.path) return (route.path || '').toLowerCase();
    }
  }
  return null;
};

export const formatDate = (date) => {
  return format(date, "yyyy-MM-dd");
};
export const formatDoctorDate = (dateString) => {
  const date = new Date(dateString);
  const formattedDate = format(date, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
  const encodedDate = encodeURIComponent(formattedDate);
  return encodedDate;
};

export const convertDateFormat = (dateString) => {
  const formattedDate = moment
    .utc(dateString)
    .local()
    .format("YYYY-MM-DD HH:mm:ss");
  return formattedDate;
};
export const convertSecondsToMinSec = (seconds) => {
  const duration = moment.duration(seconds, "seconds");
  const formattedTime = moment.utc(duration.asMilliseconds()).format("mm:ss");
  return formattedTime;
};
export function reduceArray(data, key) {
  const result = {};

  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    const name = item.agent;
    const keyWord = item[key];

    if (result[name]) {
      result[name].push(keyWord);
    } else {
      result[name] = [keyWord];
    }
  }

  return result;
}
export const filterAndSortLogsByKeyword = (logs, keywords) => {
  const filteredLogs = logs.filter((log) => {
    if (log.event_id) {
      const logText = log.event_id;
      return keywords.some((keyword) => logText.includes(keyword));
    }
    return false;
  });

  const sortedLogs = filteredLogs.sort((alog, currentLog) => {
    return new Date(currentLog.updated_at) - new Date(alog.updated_at);
  });

  return sortedLogs;
};
export const filterAndSortLogsByOther = (logs, excludeKeywords) => {
  const filteredLogs = logs.filter((log) => {
    if (log.event_id) {
      const logText = log.event_id.toLowerCase();
      return !excludeKeywords.some((keyword) =>
        logText.includes(keyword.toLowerCase())
      );
    }
    return false;
  });

  const sortedLogs = filteredLogs.sort((a, b) => {
    return new Date(b.updated_at) - new Date(a.updated_at);
  });

  return sortedLogs;
};
export const distributeRevenueToDate = (revenue, dates) => {
  const _data = [];
  const _startDate = new Date(dates[0]);
  const _endDate = new Date(dates[1]);

  const _noOfDays =
    Math.floor((_endDate - _startDate) / (1000 * 60 * 60 * 24)) + 1;
  const _mod = revenue % _noOfDays;
  const _div = (revenue - _mod) / _noOfDays;

  for (let i = 0; i < _noOfDays; i++) {
    let _revenue = 0;
    let _target_date = moment(_startDate);

    if (i < _mod) {
      _revenue = _div + 1;
      _target_date = _target_date.add(i, "days");
    } else {
      _revenue = _div;
      _target_date = _target_date.add(i, "days");
    }

    _data.push({ revenue: _revenue, target_date: _target_date });
  }

  return _data;
};

export const getValue = (object, path) => get(object, `${path}`, "");
export const getQueryParams = (name) => {
  const query = new URLSearchParams(window.location.search);
  return name === "pageNumber" ? parseInt(query.get(name)) : query.get(name);
};

export const getSearchParams = () => {
  const query = new URLSearchParams(window.location.search);
  return query.toString();
};

export const generateQuery = (items) => {
  const query = new URLSearchParams(window.location.search);
  items.map((item) => {
    Object.entries(item).map(([key, value]) => {
      if (value)
        return query.has(key)
          ? query.set(key, value)
          : query.append(key, value);
      else return query.delete(key);
    });
    return query;
  });
  return query.toString();
};
export const statusTagColor = {
  new: "success",
  hot: "danger",
  cold: "info",
  dropped: "warning",
  invalid: "primary",
  not_connected: "secondary",
};

export const getLineItemsName = (items) => {
  if (isEmpty(items)) return "";

  return items
    .map((item) => ` ${item.name} (${item.fulfillable_quantity}) `)
    .join("/");
};

const ORDER_SUBSCRIPTION_PLATFORMS = ["recurpay"];

export const getSubscriptionPlatform = (orderMeta) => {
  const _res = ORDER_SUBSCRIPTION_PLATFORMS.filter((item) => {
    return orderMeta.tags.includes(item);
  });

  return _res.join(", ");
};

export const weekOptions = [
  { label: "Sunday", value: 0 },
  { label: "Monday", value: 1 },
  { label: "Tuesday", value: 2 },
  { label: "Wednesday", value: 3 },
  { label: "Thursday", value: 4 },
  { label: "Friday", value: 5 },
  { label: "Saturday", value: 6 },
];

export const levelOptions = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
];

export const orderedProductDetails = (productsData) => {
  let customOrder = [
    "Anti-Dandruff Shampoo",
    "Recap Serum",
    "Minoxidil 5%",
    "Minoxidil 2%",
    "Health Tatva",
    "Nasal Drops",
    "Hair Ras",
    "Hair Vitamin With Biotin",
    "Gutt Shuddhi",
    "Scalp Oil 100ml with Calm Oil Shot",
    "Scalp Oil 100ml with Dandruff Oil Shot",
    "Scalp Oil 100ml with Growth Oil Shot",
    "Scalp Oil 100ml with Scalp Health Oil Shot",
    "Scalp Oil 50ml with Calm Oil Shot",
    "Scalp Oil 50ml with Dandruff Oil Shot",
    "Scalp Oil 50ml with Growth Oil Shot",
    "Scalp Oil 50ml with Scalp Health Oil Shot",
    "Anti Dandruff Solution",
    "Defence shampoo",
    "Digest Boost for Improved Digestive Ability",
    "Thyro Santulan",
    "Mom Santulan",
    "PCOS Santulan",
    "HER Santulan",
    "Hydrate Damage Repair Shampoo",
    "Cholest Vati Natural Metabolic Booster that Lowers Cholesterol",
    "Scalp Oil 80ml",
    "Dandruff Oil Shot",
    "Calm Oil Shot",
    "Scalp Health Oil Shot",
    "Growth Oil Shot",
    "Nourish Hair Oil",
    "Consti Clear for Improved Bowel Movement",
    "Minoxidil Tablet 3X10",
    "Calm Ras",
    "Iron Santulan 120 Tablets",
    "Hair Vitamin For Her",
    "Minoxidil 2%, Alcohol-free",
    "Minoxidil 5%, Alcohol-free",
    "Defence Shampoo 180ml",
    "Hair Actives Serum",
    "Hair Santulan 03",
    "Hair Santulan 02",
    "Hair Santulan 01",
    "Hair Ras 09",
    "Hair Ras 06",
    "Hair Ras 05",
    "Hair Ras 02",
    "Hair Ras 01",
    "Her Nourish"
  ];

  if(doctor.includes(getCurrentUserRole())) {
    customOrder = [
      ...customOrder,
      "Kamdudha Ras",
    ];
  }

  const products = productsData?.filter((product) =>
    customOrder.includes(product?.medicine?.display_name)
  );
  return products;
};

export const orderedProducts = (customerData, productsData, kitData=[]) => {
  const role = getCurrentUserRole();

  const hasRoleBasedExtraAccess = [ROLES_NAME.DOCTOR, ROLES_NAME.SUPER_ADMIN, ROLES_NAME.ADMIN, ROLES_NAME.CLINIC_DOCTOR].includes(role);

  const customOrder = [
    "47329496826034",//Anti-Dandruff Shampoo with Ketoconazole
    "46990309425330", //"Calm Oil Shot",
    "47276517195954", //Calm Ras
    // "46466912387250", //Cholest Vati
    "47276511199410", //Consti Clear for Improved Bowel Movement
    "46990314930354", //Dandruff Oil Shot
    "44650256728242", //Defence Conditioner
    "47301151064242", //Defence shampoo
    // "Defence Shampoo 180ml",
    "46528963936434", //Digest Boost for Improved Digestive Ability
    "46990294778034", //Growth Oil Shot
    "46528902496434", //Gutt Shuddhi
    "46528906821810", //Hair Ras
    "47303097352370", //Hair Vitamin For Her
    "47303072710834", //Hair Vitamin With Biotin
    "47276523749554", //Health Tatva
    "46466095906994", //Her Santulan
    "46465792704690", //Iron Santulan 120 Tablets
    "46528923304114", //Anti Dandruff Solution
    "47329517568178", //Minoxidil 2%
    "47276531417266", //Minoxidil 2%, Alcohol-free
    "47302891929778", //Minoxidil 5%
    "46465512898738", //Minoxidil 5%, Alcohol-free
    // "Minoxidil Tablet 3X10",
    "46466402779314", //Mom Santulan
    "47276533121202", //Nasal Drops
    "47302951403698", //Nourish Hair Oil
    // "PCOS Santulan",
    "41645770309810", //Recap Serum
    "47301148803250", //Shine Leave-in Serum
    // "44479647711410", //Scalp Health Oil Shot
    "46529938751666", //Scalp Oil 100ml
    "46530283012274", //Scalp Oil 100ml with Calm Oil Shot
    "46530320040114", //Scalp Oil 100ml with Dandruff Oil Shot
    "46530384527538", //Scalp Oil 100ml with Growth Oil Shot
    "46531529638066", //Scalp Oil 100ml with Scalp Health Oil Shot
    "46529943273650", //"Scalp Oil 50ml",
    "46530268987570", //Scalp Oil 50ml with Calm Oil Shot
    "46530365751474", //Scalp Oil 50ml with Dandruff Oil Shot
    "46531521872050", //Scalp Oil 50ml with Growth Oil Shot
    "46531537273010", //Scalp Oil 50ml with Scalp Health Oil Shot
    "46466225438898", // Thyro Santulan
    "47302857621682", //Her Nourish
    "43060739440818",
    "46990310310066",
    "46990294778034",
    "43060740030642",
    ...(hasRoleBasedExtraAccess ? ['47300731568306'] : []), // Hair Actives Serum
  ];

  const doctorMedicines = [
    "47329496826034",
    "41645770309810", //Recap Serum
    "47302891929778",//Minoxidil 5%
    "47329517568178", // "Minoxidil 2%"
    "47303072710834", //Hair Vitamin",
    "46528923304114", //"Ketoconazole 2% Night Lotion",
    "47301151064242", //Defence shampoo
    "43924864598194", //"Minoxidil Tablet 3X10",
    "45584051339442", //'Kamdudha Ras'
  ];
  // const removedProducts = [
  //   "43086511472818", //"Damage Repair Combo",
  //   "41693129212082",//"Energy Boost Combo",
  //   "37856221626546", //"Kevon Lotion",
  //   "Onabet",
  //   "Scalp Controller | Plant Based Dandruff Treatment for Itchy Scalp",
  //   "Sleep Well Combo",
  //   "Ultimate Hair supplements combo with the power of two",
  // ];

  const remainingItems = [];

  const maleRestrictedItems = [
    "46466402779314", //Mom Santulan
    "47329517568178", //"Minoxidil 2%"
    // "PCOS Santulan",
    "46466095906994", //"HER Santulan"
    // "46465726513330",
    // "Iron Santulan",
    "47303097352370", //Hair Vitamin For Her
    "46465596719282", //"Minoxidil 2%, Alcohol-free"
    "47276531417266", //"Minoxidil 2%, Alcohol-free new price 3"
    "46530283012274", //Scalp Oil 100ml with Calm Oil Shot
    "46530320040114", //Scalp Oil 100ml with Dandruff Oil Shot
    "46530384527538", //Scalp Oil 100ml with Growth Oil Shot
    "46531529638066", //Scalp Oil 100ml with Scalp Health Oil Shot
    "44422009323698", //"Defence Shampoo 180ml",
    "44650256728242", //Defence Conditioner
    "47301148803250", //Shine Leave-in Serum
    "47302857621682" //Her Nourish
  ];

  const opsRemoveProduct = [
    "46529938751666", //Scalp Oil 100ml
    "46529943273650", //"Scalp Oil 50ml",
    "46990314930354", //Dandruff Oil Shot
    "46990309425330", //"Calm Oil Shot",
    // "46990310310066", //Scalp Health Oil Shot
    "46990294778034", //"Growth Oil Shot",
    "43060739440818",
    "46990310310066",
    "46990294778034",
    "43060740030642"
  ];

  const femaleRestrictedItems = [
    "47302891929778", //Minoxidil 5%
    "46465512898738", //Minoxidil 5%, Alcohol-free
    "46530268987570", //"Scalp Oil 50ml with Calm Oil Shot",
    "46530365751474", //Scalp Oil 50ml with Dandruff Oil Shot
    "46531521872050", //Scalp Oil 50ml with Growth Oil Shot
    "46531537273010" //Scalp Oil 50ml with Scalp Health Oil Shot
  ];

  const formulationProductId = [
    '47302757875890',
    '47301161091250',
	  '46464896630962',
    '47301139169458',
    '46464745308338',
    '47302996394162',
    '47446793879730',
    '47303079166130',
  ]

  const oldFormulationProductId = [
    '45021604839602',
    '45021624565938',
    '45021630038194',
    '45021653696690',
    '45021657727154',
    '45026320777394',
    '45026320810162',
    '45026321039538',
  ]

  const newFormulationOldToNewMap = {
    '45021604839602': '47302757875890',
    '45021624565938': '47301161091250',
    '45021630038194': '46464896630962',
    '45021653696690': '47301139169458',
    '45021657727154': '46464745308338',
    '45026320777394': '47302996394162',
    '45026320810162': '47446793879730',
    '45026321039538': '47303079166130',
    '46464824213682': '47301139169458',
    '46464672661682': '47302996394162',
    '46464530186418': '47303079166130',
    '46465032159410': '47302757875890',
    '46464959742130': '47301161091250',
    '46464615710898': '47446793879730'
  }

  const genderRestrictedItems =
    customerData?.user?.gender === "F"
      ? femaleRestrictedItems
      : maleRestrictedItems;

  const oralMinoxFlag = customerData.caseTags?.filter(
    (item) => item.tag.display_name == "Oral Minoxidil"
  );
  const oralMedicine = "43924864598194";

  if (productsData.length) {
    const userId = [
      "663a693e-7a81-4e0e-a22a-bdf3b182bab5",
      "94e99693-4c46-4f10-b0e9-6304ffbb1d33",
      "4d2b3116-81f8-4901-8a63-144e154b051f",
      "eb4012d2-408b-4e22-b979-4c5af9dc2aab",
      "9902e84b-77f1-40b8-9f83-455da024610b",
      "fd943547-1364-44be-a09e-147663872839",
    ];
    let id = secureLocalStorage.getItem("id");
    const extraProductAccess = [
      '9902e84b-77f1-40b8-9f83-455da024610b',
      '20e847fb-ad35-422e-8f1b-094d8bc7ac67',
      '9902e84b-77f1-40b8-9f83-455da024610b',
      "fd943547-1364-44be-a09e-147663872839",
    ].includes(id);
    const filteredProducts = productsData.filter((product) => {
      if (userId.includes(id) || customDiscountAndZeroValueOrderEmails.includes(secureLocalStorage.getItem("email"))) {
        return true;
      } else if (
        genderRestrictedItems.includes(product?.product_principal_id)
      ) {
        return false;
      }
      return true;
    });

    let formulationProductData = kitData
    ? kitData.nextMonthProductDetails
        ?.filter(product => formulationProductId.includes(product?.product_id))
        ?.map(item => item?.product_id)
    : [];

    let customOrderedProduct = [];
    const productToMap = customOrder

    productToMap.forEach((orderedProduct) => {
      filteredProducts.forEach((product) => {
        if (
          orderedProduct === product.product_principal_id &&
          product.product_principal_id === oralMedicine &&
          oralMinoxFlag?.length
        ) {
          customOrderedProduct.push(product);
        } else if (
          orderedProduct === product.product_principal_id &&
          product.product_principal_id !== oralMedicine
        ) {
          customOrderedProduct.push(product);
        } else if (!remainingItems.includes(product)) {
          remainingItems.push(product);
        }
      });
    });

    // customOrderedProduct = customOrderedProduct.filter((product) => {
    //   if (!removedProducts.includes(product)) return product;
    // });

    if (hasRoleBasedExtraAccess || extraProductAccess) {
      formulationProductData = formulationProductId;
    } else {
      let formulationProductOrdData = customerData?.orders?.flatMap((product) =>
        product?.order_meta?.line_items
          ?.filter((product) => (formulationProductId.includes(String(product?.variant_id)) || oldFormulationProductId.includes(String(product?.variant_id))))
          .map((item) => newFormulationOldToNewMap[String(item?.variant_id)] ?? String(item?.variant_id))
      ) || [];
      formulationProductData = formulationProductOrdData?.length ? formulationProductOrdData : formulationProductData;
    }

    const filterFormulationProduct = size(formulationProductData) ? productsData?.filter((product) => {
      if (formulationProductData.includes(product?.product_principal_id)) return product;
    }):[];

    customOrderedProduct = [...customOrderedProduct, ...filterFormulationProduct];

    const recapProductId = "44668242329778"
    const activeSerumId = "47300731568306"
    const defCondFiftyGramId = "45277154377906";
    const kamududhaRasId = "45584051339442";

    const recapSerum = kitData?.nextMonthProductDetails?.some((product) => product?.product_id == recapProductId);
    //Added changes for kamudha Ras
    const kamuddhaRas = kitData?.nextMonthProductDetails?.some((product) => product?.product_id === kamududhaRasId);


    if(recapSerum){
      const recapProduct = productsData?.find((product)=> product?.product_principal_id == recapProductId);
      customOrderedProduct = [...customOrderedProduct, recapProduct];
      customOrderedProduct = filter(customOrderedProduct, (product) => get(product, ['product_principal_id'], null) !== "41645770309810")
    }
    if(kamuddhaRas || ["omkarsanas@traya.health", "nirbhay@traya.health", "nirbhay@trayahealth.com", "abhishekbadhe@traya.health"].includes(secureLocalStorage.getItem("email"))){
      const kamuddhaRasProduct = productsData?.find((product)=> product?.product_principal_id == kamududhaRasId);
      customOrderedProduct = [...customOrderedProduct, kamuddhaRasProduct];
    }
//Active serum related changes
    const activeSerum = kitData?.nextMonthProductDetails?.some((product) => product?.product_id == activeSerumId);
    const isActiveSerumOrdered = customerData?.orders?.some((product) => product?.order_meta?.line_items?.some((product) => product?.variant_id == activeSerumId));

    if(activeSerum || isActiveSerumOrdered){
      if (!hasRoleBasedExtraAccess) {
        const activeSerumProduct = productsData?.find((product)=> product?.product_principal_id == activeSerumId);
        customOrderedProduct = [...customOrderedProduct, activeSerumProduct];
      }
      customOrderedProduct = filter(customOrderedProduct, (product) =>  !["41645770309810", '44668242329778'].includes(get(product, ['product_principal_id'], null)) || extraProductAccess)
    }
// it is used to concat product in ordern on basis of principal id, no need to worry
    if([
      '9902e84b-77f1-40b8-9f83-455da024610b',
      '20e847fb-ad35-422e-8f1b-094d8bc7ac67',
      '9902e84b-77f1-40b8-9f83-455da024610b',
      'ebfc6347-c279-482f-8179-70dc70a37553',
      'fd943547-1364-44be-a09e-147663872839'
    ].includes(id)){
      const activeSerumProduct = productsData?.find((product)=> product?.product_principal_id == activeSerumId);
      const defenceConditionerFiftyGram = productsData?.find((product)=> product?.product_principal_id == defCondFiftyGramId);
      customOrderedProduct = [...customOrderedProduct, activeSerumProduct, defenceConditionerFiftyGram];
    }

    if (secureLocalStorage.getItem("email") === "nikhilsavant@traya.health") {
      const defenceConditionerFiftyGram = productsData?.find((product) => product?.product_principal_id == defCondFiftyGramId);
      if (defenceConditionerFiftyGram && !customOrderedProduct.includes(defenceConditionerFiftyGram)) {
        customOrderedProduct = [...customOrderedProduct, defenceConditionerFiftyGram];
      }
    }

    const isLead = getValidOrderCount(customerData?.orders) === 0;
    if (isLead) {
      customOrderedProduct = customOrderedProduct.filter(
        (product) => get(product, ['product_principal_id'], null) !== "41645770309810"
      );
    }

    const orderedItems = customOrderedProduct.concat(
      remainingItems.filter((product) => !remainingItems.includes(product))
    );
// Here we are only filter ptoduct for ops
    if (
      customDiscountAndZeroValueOrderEmails.includes(
        secureLocalStorage.getItem("email")
      )
    ) {
      return orderedItems;
    } else {
      const filteredOrdersOps = orderedItems?.filter(
        (product) => !opsRemoveProduct.includes(product?.product_principal_id)
      );
      return filteredOrdersOps;
    }
  }
  return [];
};

export const weeklyCall = [
  "Week #1",
  "Week #2",
  "Week #3",
  "Week #4",
  "Week #5",
  "Week #6",
  "Prescription Call",
  "retention",
];

export const slotIVRCall = ["SLOT_BOOKING", "IVR_BOOKING", "FEEDBACK_CALL"];

export const showShopifyLinkAccess = ["admin", "dispatch", "operations"];

export const getShopifyLink = (order_number) => {
  return baseURL.API_URL_BASE.includes("dev")
    ? `https://admin.shopify.com/store/trayahealthdevelop/orders/${order_number}`
    : `https://admin.shopify.com/store/tatvahealth/orders/${order_number}`;
};
//Engagement.jsx functions
export function convertObjectToFormat(data) {
  let result = {};
  let weekNumbers = Array.from(
    { length: 6 },
    (value = "Week", index) => `${value} #${index + 1}`
  );
  let emptyData = Array.from({ length: 10 }, () => `-`);
  data?.forEach((item) => {
    const tag = item.tag;
    weekNumbers = weekNumbers.filter((week) => {
      return week !== tag;
    });
    if (!result[tag]) {
      result[tag] = [];
    }

    result[tag].push(
      item.any_product_reaction || "-",
      item.customer_adherence || "-",
      item.adherence_reason || "-",
      item.energy || "-",
      item.gut_health || "-",
      item.hair_growth || "-",
      item.hair_loss || "-",
      item.mood || "-",
      item.any_product_reaction || "-",
      item.not_ordering_reason || "-"
    );
  });
  weekNumbers?.forEach((week) => {
    result = { ...result, [week]: emptyData };
  });
  return result;
}
export function convertToPrescriptionArray(prescription) {
  if (Array.isArray(prescription)) {
    return prescription;
  } else if (prescription && typeof prescription === "object") {
    return [prescription];
  }
  return [];
}

export const totalPriceCalculated = (
  totalPrice,
  discountValue = 0,
  type,
  coinDiscount = 0,
  creditDiscount = 0
) => {
  let priceToReturn = totalPrice || 0;

  // Apply discount ONLY if discount exists
  if (discountValue && type) {
    if (type === "percentage") {
      priceToReturn = priceToReturn - (priceToReturn * discountValue) / 100;
    } else {
      priceToReturn = priceToReturn - discountValue;
    }
  }

  // ✅ Apply coin discount (already expected behavior)
  if (coinDiscount) {
    priceToReturn = priceToReturn - coinDiscount;
  }

  if (creditDiscount) {
    priceToReturn = priceToReturn - creditDiscount;
  }

  // Final safety
  return priceToReturn > 0 ? Number(priceToReturn).toFixed(2) : 0;
};

export function itemList(obj) {
  const entries = Object.entries(obj);
  const stringified = entries.map(([key, value]) => `${key}:${value}`);
  return stringified.join(",");
}
export const convertDateStringToDate = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export function convertDateToTime(dateString) {
  const date = new Date(dateString);
  const options = { hour: "2-digit", minute: "2-digit", hour12: true };
  const time = date.toLocaleTimeString("en-US", options);
  return time;
}
export function formatDateTime(date, time) {
  const formattedDate = date.toISOString().split("T")[0];
  const formattedTime = time.replace(" ", "").toUpperCase();
  const timeWithoutMeridiem = formattedTime.slice(0, -2);
  const formattedDateTime = `${formattedDate}T${timeWithoutMeridiem}:00+05:30`;
  return formattedDateTime;
}
export const _formatDate = (inputDate) => {
  const date = new Date(inputDate);
  const options = { day: "numeric", month: "long", year: "numeric" };
  return date.toLocaleDateString("en-US", options);
};

export const convertToIndianTime = (dateString) => {
  const indianTime = moment.tz(dateString, "Asia/Kolkata");
  return indianTime.toISOString();
};
export function extractData(data) {
  const result = [];

  for (const item of data) {
    const active = item.active;
    const _1order_activeCount = item._1order.activeCount;
    const _2order_activeCount = item._2order.activeCount;
    const _3order_activeCount = item._3order.activeCount;
    const _3plusorder_activeCount = item._3plusorder.activeCount;

    const lost = item.lost;
    const _1order_lost = item._1order.lost;
    const _2order_lost = item._2order.lost;
    const _3order_lost = item._3order.lost;
    const _3plusorder_lost = item._3plusorder.lost;

    const row = [
      active,
      lost,
      _1order_activeCount,
      _1order_lost,
      _2order_activeCount,
      _2order_lost,
      _3order_activeCount,
      _3order_lost,
      _3plusorder_activeCount,
      _3plusorder_lost,
    ];

    result.push(row);
  }
  return result;
}
export function convertObjectForActiveTable(obj) {
  const header = ["Time", "Active", "Call", "IVR", "SLOT", "Chat"];
  const result = { header };

  const keyMap = {
    _1order: "1 Order",
    _2order: "2 Order",
    _3order: "3 Order",
    _3plusorder: "3+ Orders",
  };

  Object.entries(obj)?.forEach(([key, value]) => {
    if (key !== "active") {
      let data = [keyMap[key] || key];
      header.slice(1).forEach((column) => {
        data.push(value[column.toLowerCase() + "Count"] || 0);
      });
      if (!data[5]) {
        data[5] = "-";
      }

      result[data[0]] = data;
    }
  });

  return result;
}
export function convertObjectForLostTable(obj) {
  const header = ["Time", "Lost", "Calls", "IVR", "SLOT", "Chat"];
  const result = { header };

  Object.entries(obj)?.forEach(([key, value]) => {
    if (key !== "lost") {
      let data = [key];
      header.slice(1)?.forEach((column) => {
        data.push(value[column.toLowerCase()] || 0);
      });
      if (key === "_1order") {
        data[0] = "1 Order";
      } else if (key === "_2order") {
        data[0] = "2 Order";
      } else if (key === "_3order") {
        data[0] = "3 Order";
      } else if (key === "_3plusorder") {
        data[0] = "3+ Orders";
      }

      result[data[0]] = data;
    }
  });
  return result;
}

export function convertActiveToObject(data) {
  const legend = ["Active", "Calls", "IVR", "Slots", "Chats"];
  const categories = ["Order 1", "Order 2", "Order 3", "Order 3+"];

  const series = legend.map((name) => {
    return {
      name,
      data: [
        data._1order[name.toLowerCase() + "Count"] || 0,
        data._2order[name.toLowerCase() + "Count"] || 0,
        data._3order[name.toLowerCase() + "Count"] || 0,
        data._3plusorder[name.toLowerCase() + "Count"] || 0,
      ],
    };
  });

  return {
    legend,
    categories,
    series,
  };
}
export function convertLostToObject(data) {
  const legend = ["Lost", "Calls", "IVR", "Slots", "Chats"];
  const categories = ["Order 1", "Order 2", "Order 3", "Order 3+"];

  const series = legend.map((name) => ({
    name,
    data: [
      data._1order[name.toLowerCase()] || 0,
      data._2order[name.toLowerCase()] || 0,
      data._3order[name.toLowerCase()] || 0,
      data._3plusorder[name.toLowerCase()] || 0,
    ],
  }));

  return {
    legend,
    categories,
    series,
  };
}

export const getTotalPrice = (items) =>
  items
    .map(({ unit, price }) => unit * price)
    .reduce((total, currentValue) => total + currentValue, 0);

export const getProductItemCalculatedData = (unit, price, totalPrice) => {
  const productTotalPrice = unit * price;
  const percentage = ((productTotalPrice * 100) / totalPrice).toFixed(0);
  return { productTotalPrice, percentage };
};
export const formateQueryDate = (date) => {
  return format(date, "yyyy-MM-dd");
};

export function convertDateformat(inputDate) {
  if (inputDate) {
    const [year, month, day] = inputDate.split("-");
    const outputDate = `${day}-${month}-${year}`;
    return outputDate;
  }
}
export function getDateAndDay(num = 0) {
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const now = new Date();
  const currentTimestamp = now.getTime();
  const oneDayInMilliseconds = 24 * 60 * 60 * 1000;

  const targetTimestamp = currentTimestamp + num * oneDayInMilliseconds;
  const targetDate = new Date(targetTimestamp);
  const targetDayOfWeek = daysOfWeek[targetDate.getDay()];
  const targetFormattedDate = targetDate.toISOString().split("T")[0];

  return {
    day: targetDayOfWeek,
    date: targetFormattedDate,
  };
}

const startTime = 9;
const endTime = 21;

export const timeArray = Array.from(
  { length: (endTime - startTime) * 2 + 1 },
  (_, index) => {
    const hour = Math.floor(index / 2 + startTime);
    const minutes = index % 2 === 0 ? "00" : "30";

    if (hour === endTime && minutes === "30") {
      return null;
    }

    return `${hour.toString().padStart(2, "0")}:${minutes}`;
  }
).filter(Boolean);

export function calculateDateDifference(startDate, endDate) {
  const oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffInMilliseconds = Math.abs(end - start);
  const diffInDays = Math.round(diffInMilliseconds / oneDay);

  return diffInDays;
}
export const getMaxDate = (date) => {
  if (!date) return null;
  const maxDate = new Date(date);
  maxDate.setDate(maxDate.getDate() + 6);
  return maxDate;
};

export const getMinDate = (date) => {
  if (!date) return null;
  const minDate = new Date(date);
  minDate.setDate(minDate.getDate() - 6);
  return minDate;
};
export function generateUniqueId() {
  return Math.random().toString(36).substring(2, 15);
}
export const _getMaxDate = (date) => {
  if (!date) return null;
  const maxDate = new Date(date);
  maxDate.setDate(maxDate.getDate() + 1);
  return maxDate;
};

export const _getMinDate = (date) => {
  if (!date) return null;
  const minDate = new Date(date);
  minDate.setDate(minDate.getDate() - 1);
  return minDate;
};

export const getMaxDateByDate = (date) => {
if (!date) return null;
const maxDate = new Date(date);
maxDate.setDate(maxDate.getDate() + 2);
return maxDate;
};
export const getMinDateByDate = (date) => {
  if (!date) return null;
  const minDate = new Date(date);
  minDate.setDate(minDate.getDate() - 2);
  return minDate;
};
export const getColor = (color) => {
  switch (color) {
    case "primary":
      return "#007bff";
    case "danger":
      return "#dc3545";
    case "info":
      return "#17a2b8";
    case "success":
      return "#28a745";
    case "warning":
      return "#ffc107";
    case "gray-100":
      return "#f8f9fa";
    case "gray-300":
      return "#e9ecef";
    case "gray-600":
      return "#6c757d";
    case "dark":
      return "#343a40";
    default:
      return "black";
  }
};
export const formatPhoneNumber = (text) => {
  const isPhoneNumber = /^\d{10}$/.test(text);
  const isLongPhoneNumber = /^\d{12}$/.test(text);
  if (isPhoneNumber && !text.startsWith("+91")) {
    return `+91${text}`;
  } else if (isLongPhoneNumber && !text.startsWith("+")) {
    return `+${text}`;
  }
  return text;
};

export function decreaseDateByOneDay(dateString) {
  return moment(dateString).subtract(1, "day").format("YYYY-MM-DD");
}
export const filterDate = (date) => {
  const selectedYear = moment(date).year();
  const currentYear = moment().year();
  const currentMonth = moment().month();

  if (selectedYear === currentYear) {
    return date.getMonth() <= currentMonth;
  } else if (selectedYear < currentYear) {
    return false;
  }

  return true;
};
export const getMaxDate_ = (date) => {
  if (!date) return null;
  const maxDate = new Date(date);
  maxDate.setDate(maxDate.getDate() + 2);
  return maxDate;
};

export const getMinDate_ = (date) => {
  if (!date) return null;
  const minDate = new Date(date);
  minDate.setDate(minDate.getDate() - 2);
  return minDate;
};
export function removeSpaces(input) {
  let result;
  if (typeof input === "string") {
    result = input.trim();
  } else if (typeof input === "number") {
    result = parseFloat(input.toString().trim());
  } else {
    result = input;
  }
  return result;
}
export const formatDate_ = (dateString, turn) => {
  const date = new Date(dateString);
  if (turn === "start") date.setHours(0, 0, 0, 0);
  else date.setHours(23, 59, 59, 0);
  const options = {
    weekday: "short",
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "Asia/Kolkata",
  };

  const formattedDate = date
    .toLocaleString("en-US", options)
    .replace(/,/g, "")
    .replace(/ /g, "+")
    .replace(/:/g, "%3A");

  return formattedDate + `+GMT%2B0530`;
};
export const todayStartDate = moment()
  .startOf("day")
  .format("ddd+MMM+D+YYYY+18%3A30%3A00+GMT%2B0530");

export const todayEndDate = moment()
  .endOf("day")
  .format("ddd+MMM+D+YYYY+18%3A29%3A99+GMT%2B0530");

export const orderOptions = [
  { value: "1", label: "One" },
  { value: "2", label: "Two" },
  { value: "3", label: "Three" },
  { value: "4", label: "Three Plus(+)" },
];

export const orderCancellationTl = [
  "superadmin@tenant.com",
  "agarwalsandip@traya.health",
  "sindhu@traya.health",
  "nirajsurve@traya.health",
  "patilgaurang@traya.health",
];
export const zeroValueCategory = [
  {
    label: "Lost",
    value: "lost",
  },
  {
    label: "Replacement",
    value: "replacement",
  },
  {
    label: "Damaged",
    value: "damaged",
  },
  {
    label: "Sample Order",
    value: "sample",
  },
];

export const customDiscountAccess = [
  "agarwalsandip@traya.health",
  "nirajsurve@traya.health",
  "superadmin@tenant.com",
  "nirbhay@trayahealth.com",
  "shubham@trayahealth.com",
  "vaibhavghag@traya.health",
  "neelamshaikh@traya.health",
  "aakashbhatia@traya.health",
  "lovelymondal@traya.health",
  "shraddhapawar@traya.health",
  "ketkighadigaonkar@traya.health",
  "tejasdoiphode@traya.health",
  "darshanakadam@traya.health",
  "tejasgaikwad@traya.health",
  "tejasgaikwad@traya.health",
  "silpapillai@traya.health",
  "aurangzebkhan@traya.health",
  "shreyasparakal@traya.health",
  "amitgupta@traya.health",
  "ajinkyabandiwadekar@traya.health",
  "sumeetkumar@traya.health",
];

export const partialRefundAccess = [
  "sindhu@traya.health",
  "tejasdoiphode@traya.health",
  "adityac@traya.health",
  "shubham@trayahealth.com",
];
export const refundViaApiStatus = [
  "rev picked up",
  "rev in transit",
  "rev out for delivery",
  "rev delivered",
  "rev undelivered",
];

export const updatedDiscounts = [
  {
    label: "REGHC07",
    value: "REGHC07",
    code: "REGHC07",
    amount: 7,
    type: "percentage",
  },
  {
    label: "REGHC12",
    value: "REGHC12",
    code: "REGHC12",
    amount: 12,
    type: "percentage",
  },
  {
    label: "REGHC20",
    value: "REGHC20",
    code: "REGHC20",
    amount: 20,
    type: "percentage",
  },
];
export const orderCancellation = [
  "agarwalsandip@traya.health",
  "sindhu@traya.health",
  "nirajsurve@traya.health",
  "patilgaurang@traya.health",
  "superadmin@tenant.com",
  "anandkartik@traya.health",
  "shobha@traya.health",
  "shubham@trayahealth.com",
  "santimaplarsapna@traya.health",
];

export const questions = [
  "Hair Fall duration",
  "Past Hair Loss Treatments",
  "Medical History / Current medication",
  "Dandruff condition/ Scalp type",
  "Set Expectations",
  "Additional Notes (if any)",
];

export const onBoardingQuestions = [
  "dandruff_description",
  "hairfall_description",
  "language",
];

export const typeOptions = [
  { label: "Value", value: "value" },
  { label: "Percentage", value: "percentage" },
];

export const subCategoryMap = [
  { label: "Address or Phone Change", value: "edit_order" },
  { label: "Order Cancellation", value: "order_cancellation" },
  { label: "Reverse Pick up", value: "reverse_pick_up" },
  { label: "Return Product", value: "return_product" },
  { label: "Reattempt Product", value: "reattempt_product" },
  { label: "Mismatch Product", value: "mismatch_product" },
  { label: "Missing Product", value: "missing_product" },
  { label: "Refund", value: "refund" },
  { label: "Delivery Issues", value: "delivery_issues" },
  { label: "Damaged Product", value: "damaged_product" },
  { label: "Hairfall", value: "hairfall_issue" },
  { label: "Constipation", value: "constipation_issue" },
  { label: "Dandruff", value: "dandruff_issue" },
  { label: "Health conditions", value: "health_issue" },
  { label: "Boils", value: "boils_issue" },
  { label: "Itching", value: "itching_issue" },
  { label: "Product Reaction", value: "product_reaction_issue" },
  { label: "Sexual issue", value: "sexual_issue" },
  { label: "Gastric issues", value: "gastric_issue" },
  { label: "Other Issue", value: "other_issue" },
  { label: "Order Related Refunds", value: "order_related_refunds" },
  { label: "Payments Issue", value: "payments_issue" },
  { label: "5 Months Money Back", value: "five_month_money_back" },
  { label: "Coach Service", value: "coach_service" },
  { label: "Angry Customer", value: "angry_customer" },
  { label: "No Results with Traya", value: "no_results_traya" },
  { label: "Negative Review", value: "negative_review" },
  { label: "Order Sync", value: "order_sync" },
  { label: "App Issue", value: "app_issue" },
  { label: "Edit Profile", value: "edit_profile" },
  { label: "Login Issues On Website", value: "login_issues_website" },
  {
    label: "International Prescription Request",
    value: "international_prescription_request",
  },
  { label: "Other Issue", value: "other_subcategory" },
  { label: "Reattempt Request", value: "reattempt_request" },
  { label: "Initiate RTO", value: "initiate_rto" },
  { label: "Tracking link not updated", value: "tracking_link_Not_updated" },
  { label: "Incorrect Tracking Status", value: "wrong_tracking_status" },
  {
    label: "Amount Paid - Order not handed over",
    value: "amount_paid_no_order",
  },
  { label: "Payment failures/ No order placed", value: "payment_failure" },
  { label: "Slot completely missed", value: "slot_missed" },
  { label: "Slot not catered on time", value: "slot_not_catered" },
  { label: "Others Issue", value: "customer_others" },
  { label: "Referral Code", value: "referral_code" },
  {
    label: "Auto Order Cancellation",
    value: "auto_order_cancellation_initiated",
  },
  { label: "Unhappy with coach", value: "unhappy_with_coach" },
  { label: "No call after booking slot", value: "no_call_after_booking" },
  { label: "Call not recieved on time", value: "call_not_on_time" },
  { label: "Other Issue", value: "other_coach_issue" },
  { label: "App not working", value: "app_not_working" },
  { label: "Prescription not visible", value: "prescription_not_visible" },
  { label: "Not able to place order", value: "not_able_to_place_order" },
  { label: "Not able to book call", value: "not_able_to_book_call" },
  { label: "Diet plan not working", value: "diet_plan_not_working" },
  { label: "Showing Error", value: "showing_error" },
  { label: "Build a habit not working", value: "build_a_habit_not_working" },
  { label: "Coins not credited", value: "coins_not_credited" },
  { label: "Unable to redeem coins", value: "unable_to_redeem_coins" },
  { label: "Other tech issue", value: "other_tech_issue" },
  { label: "Tracking link not working", value: "tracking_link_not_working" },
];
export const toggleFlags = [
  { key: "ticket_flag", label: "Ticket Flag" },
  { key: "book_a_call", label: "Book A Call" },
  { key: "chat_flag", label: "Chat Flag" },
  { key: "photo_flag", label: "Photo Flag" },
  { key: "products_flag", label: "Products Flag" },
  { key: "orderId_flag", label: "Order ID Flag" },
  { key: "customer_visible", label: "Customer Visible" },
  { key: "crm_visible", label: "CRM Visible" },
  { key: "active", label: "Active" },
  { key: "showBookCall", label: "Show Book a Call" },
];
export const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const ROLES_NAME = {
  ADMIN: "admin",
  MEDICAL_REP: "medical_rep",
  SALES: "sales",
  DOCTOR: "doctor",
  DISPATCH: "dispatch",
  SUPERVISOR: "supervisor",
  SUPPORT: "support",
  READ_ONLY: "read_only",
  CONSULT_REP: "consult_rep",
  CONSULT_DOCTOR: "consult_doctor",
  OPERATIONS: "operations",
  DOCTOR_ADMIN: "doctor_admin",
  IVR: "ivr",
  IVR_AGENT: "ivr_agent",
  CHAT: "chat",
  ORM: "orm",
  COMMUNITY: "community",
  QUALITY: "quality",
  MEDICAL: "medical",
  MEDREP_EXT: "medrep_ext",
  OPERATIONS_ADMIN: "operations_admin",
  SUPER_ADMIN: "super_admin",
  MEDREP_EXT_SS: "medrep_ext_ss",
  MEDREP_EXT_CNX: "medrep_ext_cnx",
  LEAD_AGENT: "lead_agent",
  CLINIC_EXECUTIVE: "clinic_executive",
  CLINIC_RECEPTIONIST: "clinic_receptionist",
  CLINIC_DOCTOR: "clinic_doctor",
  TEAM_LEAD: "team_lead" ,
  MAKER:"maker",
  CHECKER:"checker",
  PUBLISHER:"publisher",
  CHAT_CALL_AGENT: 'chat_call_agent',
  OUTSOURCE_QUALITY: 'outsource_quality',
  TRAINER: 'trainer'
};

export const roles = {
  "00000000-0000-0000-0000-000000000001": ROLES_NAME.ADMIN,
  "00000000-0000-0000-0000-000000000002": ROLES_NAME.MEDICAL_REP,
  "00000000-0000-0000-0000-000000000003": ROLES_NAME.SALES,
  "00000000-0000-0000-0000-000000000004": ROLES_NAME.DOCTOR,
  "00000000-0000-0000-0000-000000000006": ROLES_NAME.DISPATCH,
  "00000000-0000-0000-0000-000000000007": ROLES_NAME.SUPERVISOR,
  "00000000-0000-0000-0000-000000000008": ROLES_NAME.SUPPORT,
  "00000000-0000-0000-0000-000000000009": ROLES_NAME.READ_ONLY,
  "00000000-0000-0000-0000-000000000011": ROLES_NAME.CONSULT_REP,
  "00000000-0000-0000-0000-000000000012": ROLES_NAME.CONSULT_DOCTOR,
  "00000000-0000-0000-0000-000000000013": ROLES_NAME.OPERATIONS,
  "00000000-0000-0000-0000-000000000014": ROLES_NAME.DOCTOR_ADMIN,
  "00000000-0000-0000-0000-000000000015": ROLES_NAME.IVR,
  "00000000-0000-0000-0000-000000000016": ROLES_NAME.CHAT,
  "00000000-0000-0000-0000-000000000017": ROLES_NAME.ORM,
  "00000000-0000-0000-0000-000000000018": ROLES_NAME.COMMUNITY,
  "00000000-0000-0000-0000-000000000019": ROLES_NAME.QUALITY,
  "00000000-0000-0000-0000-000000000020": ROLES_NAME.MEDICAL,
  "00000000-0000-0000-0000-000000000022": ROLES_NAME.MEDREP_EXT,
  "00000000-0000-0000-0000-000000000023": ROLES_NAME.OPERATIONS_ADMIN,
  "00000000-0000-0000-0000-000000000026": ROLES_NAME.SUPER_ADMIN,
  "00000000-0000-0000-0000-000000000028": ROLES_NAME.MEDREP_EXT_SS,
  "00000000-0000-0000-0000-000000000029": ROLES_NAME.MEDREP_EXT_CNX,
  "00000000-0000-0000-0000-000000000032": ROLES_NAME.LEAD_AGENT,
  "00000000-0000-0000-0000-000000000034": ROLES_NAME.CLINIC_EXECUTIVE,
  "00000000-0000-0000-0000-000000000035": ROLES_NAME.CLINIC_RECEPTIONIST,
  "00000000-0000-0000-0000-000000000036": ROLES_NAME.CLINIC_DOCTOR,
  "00000000-0000-0000-0000-000000000038": ROLES_NAME.TEAM_LEAD,
  "00000000-0000-0000-0000-000000000039": ROLES_NAME.MAKER,
  "00000000-0000-0000-0000-000000000040": ROLES_NAME.CHECKER,
  "00000000-0000-0000-0000-000000000041": ROLES_NAME.PUBLISHER,
  "00000000-0000-0000-0000-000000000042": ROLES_NAME.CHAT_CALL_AGENT,
  "00000000-0000-0000-0000-000000000043": ROLES_NAME.OUTSOURCE_QUALITY,
  "00000000-0000-0000-0000-000000000044": ROLES_NAME.TRAINER,
};

// Reverse mapping: role name → UUID
export const ROLE_UUID_MAP = Object.fromEntries(
  Object.entries(roles).map(([uuid, name]) => [name, uuid])
);

// Check if user can access Improvement Plan
export const canAccessImprovementPlan = (userRole, userLevel) => {
  return (
    (userRole === ROLES_NAME.MEDICAL_REP && userLevel === 4) ||
    userRole === ROLES_NAME.DOCTOR ||
    userRole === ROLES_NAME.SUPER_ADMIN
  );
};

import { opsTeamMember } from '../../config/env';
export { opsTeamMember };

export const allowRolesSuperAdmin = ["super_admin"];

export const roleChange = ["2", "3", "4"];

export const validatePhone = (value) => /^\d{10}$/.test(value);
export const validateEmail = (value) =>
  /^[a-zA-Z0-9._%+-]+@(traya\.health|trayahealth\.com|trayahealth\.co|tatvartha\.com|tatvarthahealth\.com|tatvarthahealth\.in|vayuskin\.in|technotask\.co\.in|corp\.fusionbposervices\.com|concentrix\.com|Fusioncx\.com|squadstack\.com|gmail\.com|voitekk\.com|voitekk\.co|in\.maxicus\.com|fusioncx\.org|radmintec\.com|radicalminds\.net|drit\.in|mail\.dritm\.com|jsw\.in|ileadsemail\.com|exotel\.com|internal\.traya\.health|partner\.traya\.health)$/.test(
    value
  );

export const settingKeyOptions = [
  "ORDER_CART_BASE_URL",
  "ORDER_CANCELLATION_ASSIGNEE_CP",
  "AUTO_INVOICE",
  "ENABLE!MONGODB!ENGAGEMENTS!API",
  "TICKET_ORDER_MISSING_OR_DAMAGED_ITEM",
  "TICKET_ORDER_CANCEL_ORDER",
  "TICKET_ORDER_REVERSE_PICKUP",
  "TICKET_ORDER_ADD_PHONE_CHANGE",
  "TICKET_ORDER_RETURN_PRODUCT",
  "TICKET_ORDER_REATTEMPT_REQUEST",
  "TICKET_ORDER_MISSING_PRODUCT",
  "TICKET_ORDER_MISMATCH_PRODUCT",
  "TICKET_MEDICAL_ESCALATIONS_HAIRFALL",
  "TICKET_MEDICAL_ESCALATIONS_CONSTIPATION",
  "TICKET_MEDICAL_ESCALATIONS_DANDRUFF",
  "TICKET_MEDICAL_ESCALATIONS_HEALTH",
  "TICKET_MEDICAL_ESCALATIONS_BOILS",
  "TICKET_MEDICAL_ESCALATIONS_ITCHING",
  "TICKET_MEDICAL_ESCALATIONS_PRODUCT_REACTION",
  "TICKET_MEDICAL_ESCALATIONS_SEXUAL_ISSUE",
  "TICKET_MEDICAL_ESCALATIONS_GASTRIC_ISSUE",
  "TICKET_MEDICAL_ESCALATIONS_OTHER",
  "TICKET_PAYMENTS_REFUND",
  "TICKET_PAYMENTS_PAYMENT_ISSUE",
  "TICKET_PAYMENTS_PAYMENT_FAILURE_NO_ORDER_PLACED",
  "TICKET_PAYMENTS_REFERRAL_CODE",
  "TICKET_CUSTOMER_COMPLAINT_FIVE_MONTH_MONEY",
  "TICKET_CUSTOMER_COMPLAINT_COACH_SERVICE",
  "TICKET_CUSTOMER_COMPLAINT_ANGRY_CUSTOMER",
  "TICKET_CUSTOMER_COMPLAINT_NO_RESULT_TRAYA",
  "TICKET_CUSTOMER_COMPLAINT_NEGATIVE_REVIEW",
  "TICKET_CUSTOMER_COMPLAINT_SLOT_MISSED",
  "TICKET_CUSTOMER_COMPLAINT_SLOT_NOT_CATERED",
  "TICKET_CUSTOMER_COMPLAINT_CUSTOMER_OTHER",
  "TICKET_TECH_BUGS_ORDER_SYNC",
  "TICKET_TECH_BUGS_APP_ISSUE",
  "TICKET_TECH_BUGS_EDIT_PROFILE",
  "TICKET_TECH_BUGS_LOGIN_ISSUES",
  "TICKET_INTERNATIONAL_PRESCRIPTION_REQUEST",
  "TICKET_DELIVERY_ISSUES_REATTEMPT_REQUEST",
  "TICKET_DELIVERY_ISSUES_INITIATE_RTO",
  "TICKET_DELIVERY_ISSUES_TRACKING_LINK_NOT_UPDATED",
  "TICKET_DELIVERY_ISSUES_INCORRECT_TRACKING_STATUS",
  "TICKET_DELIVERY_ISSUES_AMOUNT_PAID_ORDER_NOT_HANDED_OVER",
  "order_related_damaged_product",
  "order_related_missing_product",
  "order_related_mismatch_product",
  "order_related_order_cancellation",
  "order_related_reverse_pick_up",
  "medical_escalations_hairfall_issue",
  "medical_escalations_hairfall_issue_2",
  "medical_escalations_hairfall_issue_3",
  "medical_escalations_hairfall_issue_4",
  "medical_escalations_hairfall_issue_5",
  "medical_escalations_constipation_issue",
  "medical_escalations_constipation_issue_2",
  "medical_escalations_constipation_issue_3",
  "medical_escalations_constipation_issue_4",
  "medical_escalations_constipation_issue_5",
  "medical_escalations_dandruff_issue",
  "medical_escalations_dandruff_issue_2",
  "medical_escalations_dandruff_issue_3",
  "medical_escalations_dandruff_issue_4",
  "medical_escalations_dandruff_issue_5",
  "medical_escalations_health_issue",
  "medical_escalations_health_issue_2",
  "medical_escalations_health_issue_3",
  "medical_escalations_health_issue_4",
  "medical_escalations_health_issue_5",
  "medical_escalations_boils_issue",
  "medical_escalations_boils_issue_2",
  "medical_escalations_boils_issue_3",
  "medical_escalations_boils_issue_4",
  "medical_escalations_boils_issue_5",
  "medical_escalations_itching_issue",
  "medical_escalations_itching_issue_2",
  "medical_escalations_itching_issue_3",
  "medical_escalations_itching_issue_4",
  "medical_escalations_itching_issue_5",
  "medical_escalations_product_reaction_issue",
  "medical_escalations_product_reaction_issue_2",
  "medical_escalations_product_reaction_issue_3",
  "medical_escalations_product_reaction_issue_4",
  "medical_escalations_product_reaction_issue_5",
  "medical_escalations_sexual_issue",
  "medical_escalations_sexual_issue_2",
  "medical_escalations_sexual_issue_3",
  "medical_escalations_sexual_issue_4",
  "medical_escalations_sexual_issue_5",
  "medical_escalations_gastric_issue",
  "medical_escalations_gastric_issue_2",
  "medical_escalations_gastric_issue_3",
  "medical_escalations_gastric_issue_4",
  "medical_escalations_gastric_issue_5",
  "medical_escalations_other_issue",
  "medical_escalations_other_issue_2",
  "medical_escalations_other_issue_3",
  "medical_escalations_other_issue_4",
  "medical_escalations_other_issue_5",
  "tech_bugs_order_sync",
  "tech_bugs_order_sync_2",
  "tech_bugs_order_sync_3",
  "tech_bugs_order_sync_4",
  "tech_bugs_app_issue",
  "tech_bugs_edit_profile",
  "tech_bugs_login_issues_website",
  "payments_order_related_refunds",
  "payments_payments_issue",
  "payments_payment_failure",
  "payments_referral_code",
  "customer_complaints_five_month_money_back",
  "customer_complaints_five_month_money_back_2",
  "customer_complaints_coach_service",
  "customer_complaints_coach_service_2",
  "customer_complaints_angry_customer",
  "customer_complaints_angry_customer_2",
  "customer_complaints_no_results_traya",
  "customer_complaints_no_results_traya_2",
  "customer_complaints_negative_review",
  "customer_complaints_negative_review_2",
  "customer_complaints_slot_missed",
  "customer_complaints_slot_missed_2",
  "customer_complaints_slot_not_catered",
  "customer_complaints_slot_not_catered_2",
  "customer_complaints_customer_others",
  "customer_complaints_customer_others_2",
  "international_prescription_international_prescription_request",
  "delivery_Issues_reattempt_request",
  "delivery_Issues_initiate_rto",
  "delivery_Issues_tracking_link_Not_updated",
  "delivery_Issues_wrong_tracking_status",
  "delivery_Issues_amount_paid_no_order",
  "coach_related_unhappy_with_coach",
  "coach_related_unhappy_with_coach_2",
  "coach_related_unhappy_with_coach_3",
  "coach_related_unhappy_with_coach_4",
  "coach_related_unhappy_with_coach_5",
  "coach_related_unhappy_with_coach_6",
  "coach_related_unhappy_with_coach_7",
  "coach_related_unhappy_with_coach_8",
  "coach_related_no_call_after_booking",
  "coach_related_no_call_after_booking_2",
  "coach_related_no_call_after_booking_3",
  "coach_related_no_call_after_booking_4",
  "coach_related_no_call_after_booking_5",
  "coach_related_no_call_after_booking_6",
  "coach_related_no_call_after_booking_7",
  "coach_related_no_call_after_booking_8",
  "coach_related_call_not_on_time",
  "coach_related_call_not_on_time_2",
  "coach_related_call_not_on_time_3",
  "coach_related_call_not_on_time_4",
  "coach_related_call_not_on_time_5",
  "coach_related_call_not_on_time_6",
  "coach_related_call_not_on_time_7",
  "coach_related_call_not_on_time_8",
  "coach_related_other_coach_issue",
  "coach_related_other_coach_issue_2",
  "coach_related_other_coach_issue_3",
  "coach_related_other_coach_issue_4",
  "coach_related_other_coach_issue_5",
  "coach_related_other_coach_issue_6",
  "coach_related_other_coach_issue_7",
  "coach_related_other_coach_issue_8",
  "tech_bugs_app_not_working",
  "tech_bugs_prescription_not_visible",
  "tech_bugs_not_able_to_place_order",
  "tech_bugs_not_able_to_book_call",
  "tech_bugs_diet_plan_not_working",
  "tech_bugs_showing_error",
  "tech_bugs_build_a_habit_not_working",
  "tech_bugs_coins_not_credited",
  "tech_bugs_unable_to_redeem_coins",
  "tech_bugs_other_tech_issue",
  "tech_bugs_tracking_link_not_working",
];
export const currentSubcatOptions = [
  { value: "CRM", label: "CRM" },
  { value: "APP", label: "APP" },
  { value: "FORM", label: "FORM" },
];

export const newSubcategory = () => ({
  subcategory: "",
  assignees: [""],
  waba: false,
  waba_template: "",
  unanswered_closing_waba: false,
  unanswered_closing_waba_template: "",
  answered_opening_waba: false,
  answered_opening_waba_template: "",
  sms: false,
  sms_template: "",
  faqs: [newFAQ()],
  reasons_flag: false,
  reasons: [],
  ask_language: false,
});

export const newFAQ = () => ({
  display_name: "",
  faq_ans: "",
  banner_image_cdn_link: [""],
  banner_video_link: "",
  ticket_flag: false,
  book_a_call: false,
  chat_flag: false,
  orderId_flag: false,
  photo_flag: false,
  products_flag: false,
  assignees: [""],
});

export const newReason = () => ({
  label: "",
  value: "",
});

export const externalUsers = ["medrep_ext_ss", "medrep_ext_cnx"];

export const externalMedrep = ["medrep_ext", "medical_rep", "medrep_ext_cnx"];

export const allowedLevels = ["1", "2", "3"];

export const required = <span className="text-danger">*</span>;
export const isImageUrl = (url) => {
  const img = new Image();
  img.src = url;
  return new Promise((resolve) => {
    img.onerror = () => resolve(false);
    img.onload = () => resolve(true);
  });
};

export const dropDownConditions = [
  { value: "gender", label: "Gender" },
  { value: "age", label: "Age" },
  { value: "form status", label: "Form Status" },
  { value: "order count", label: "Order Count" },
  { value: "order delivered date", label: "Order Delivered Date" },
  { value: "order created", label: "Order Created" },
  { value: "order status", label: "Order Status" },
  { value: "form type", label: "Form Type" },
  { value: "order type", label: "Order Type" },
  { value: "order value", label: "Order Value" },
  { value: "slot booking", label: "Slot Booking" },
  { value: "engagement tag", label: "Engagement Tag" },
  { value: "engagement reminder date", label: "Engagement Reminder Date" },
  { value: "hair loss stages", label: "Hair Loss Stages" },
];

export const conditionTypeItems = [
  { value: "=", label: "=" },
  { value: ">", label: ">" },
  { value: "<", label: "<" },
  { value: "between", label: "Between" },
];

export const genderCondition = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];
export const formStatus = [
  { value: "filled", label: "Filled" },
  { value: "transplant-lead", label: "Transplant lead" },
  { value: "draft", label: "Draft" },
  { value: "semi-filled", label: "Semi Filled" },
  { value: "guest", label: "Guest" },
  { value: "mini-lead", label: "Mini lead" },
  { value: "appt-lead", label: "Appt Lead" },
];
export const orderStatus = [
  { value: "delivered", label: "Delivered" },
  { value: "in_progress", label: "In progress" },
  { value: "shipping_pending", label: "Shipping pending" },
  { value: "pending_prescription", label: "Pending prescription" },
];
export const orderType = [
  { value: "pre_paid", label: "Pre paid" },
  { value: "cod_pending", label: "Cod pending" },
  { value: "direct", label: "Direct" },
  { value: "general", label: "General" },
  { value: "cod_approved", label: "Cod approved" },
  { value: "cod_rejected", label: "Cod rejected" },
  { value: "other", label: "Other" },
];
export const EngagementTag = [
  { value: "first_call", label: "First Call" },
  { value: "slot_booking", label: "Slot Booking" },
];
export const hairLossStages = [
  { value: "Stage-1", label: "Stage-1" },
  { value: "Stage-2", label: "Stage-2" },
  { value: "Stage-3", label: "Stage-3" },
  { value: "Stage-4", label: "Stage-4" },
  { value: "Stage-5", label: "Stage-5" },
  { value: "Stage-6", label: "Stage-6" },
  { value: "Coin Size Patch", label: "Coin Size Patch" },
  {
    value: "Heavy Hair Fall Across The Head",
    label: "Heavy Hair Fall Across The Head",
  },
  { value: "Mild Hair Fall", label: "Mild Hair Fall" },
  { value: "Heavy Hair Fall", label: "Heavy Hair Fall" },
  { value: "Hair Thinning", label: "Hair Thinning" },
  { value: "Poor Hair Quality", label: "Poor Hair Quality" },
  { value: "Hair Loss In Front", label: "Hair Loss In Front" },
  { value: "Hair Loss On Top", label: "Hair Loss On Top" },
  { value: "Both Front & Top", label: "Both Front & Top" },
  { value: "Advance Hair Loss", label: "Advance Hair Loss" },
];

export const optionsContent = [
  {
    value: "default",
    label: "Default",
  },
  {
    value: "video",
    label: "Video",
  },
  {
    value: "article",
    label: "Article",
  },
];

export const capitalizeFirstLetterOfEachWord = (str) => {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const activeStatus = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

export const slotLead = [{ label: "Lead Slot booking", value: "cold_call" }];

export const doctor = ["doctor", "consult_doctor", "clinic_doctor"];
export const medrepExt = ["medrep_ext", "medical_rep", "team_lead"];

export const usersNotAllowedForTicketStats = [
  "consult_doctor",
  "doctor",
  "support",
  "team_lead",
  "ivr",
  "medrep_ext",
  "medrep_ext_ss",
];

export const getMedRepLevel = {
  1: "PRO",
  2: "INTERMEDIATE",
  3: "BEGINNER",
};

export const sampleData = [
  { customer_email: "customer@as.com", rep_email: "rep@rep.com" },
];

export const canMarkInprogress = ["doctor_admin", "doctor"];

export const canNotMarkStatusProgress = [
  "shipping_pending",
  "shipped",
  "delivered",
  "void",
  "in_progress",
];

export const adminRole = ["admin", "super_admin", ROLES_NAME.TEAM_LEAD];

export const medRepRoles = ["medical_rep", "medrep_ext", "medrep_ext_ss"];

export const orderCancellationDisabledStatus = ["delivered", "void", "unknown"];

export const supportRole = [
  "support",
  "team_lead",
  "orm",
  "chat",
  "quality",
  "community",
  "medical",
  "ivr",
];

export const RESCHEDULE_SLOT_URL = `https://form.traya.health/pages/reschedule-slot/`;

export const COPY_FORM_URL = `https://form.traya.health/nextcart/`;
export const optionsMedType = [
  { label: "Allopathy", value: "allopathy" },
  { label: "Ayurveda", value: "ayurveda" },
];

export const THIRD_PARTY_MEDREPS = [
  "medrep_ext",
  "medrep_ext_ss",
  "medrep_ext_cnx",
  "medical_rep",
  "team_lead",
  "sales",
  "doctor",
  "community",
  "quality",
  "admin",
  "dispatch",
  "support",
  "orm",
  "chat",
  "ivr",
  "consult_rep",
  "operations",
  "medical",
  "operations_admin",
  "super_admin",
  "lead_agent",
  "clinic_receptionist",
  "clinic_doctor",
  "team_lead" ,
  "chat_call_agent"
];

export const formStatusMapper = {
  "appt-lead": "AL",
  draft: "Draft",
  filled: "Filled",
  "mini-lead": "Mini Lead",
  "semi-filled": "Semi Filled",
  "transplant-lead": "Transplant Lead",
};

export const fourPlaceHolder = () => {
  return (
    <>
      <Placeholder as="p" animation="glow">
        <Placeholder xs={12} />
      </Placeholder>
      <Placeholder as="p" animation="glow">
        <Placeholder xs={12} />
      </Placeholder>
      <Placeholder as="p" animation="glow">
        <Placeholder xs={12} />
      </Placeholder>
      <Placeholder as="p" animation="glow">
        <Placeholder xs={12} />
      </Placeholder>
    </>
  );
};

export const downloadOption = [
  {
    label: "Post Sales Orders",
    value: "post_sales_orders",
  },
];

export const specialSubCategories = [
  "boils_issue",
  "itching_issue",
  "product_reaction_issue",
  "swelling_issue",
  "non_alcohol_minoxidil_concerns"
];

export const groupSlots = (slots) => {
  if (isEmpty(slots)) return [];

  let _sortedSlots = sortAsc(slots, "slotTime");
  return returnSlotsByDates(_sortedSlots);
};

const returnSlotsByDates = (slots) => {
  return groupBy(slots, (slot) => {
    return dayjs(slot.slotTime).format("YYYY-MM-DD");
  });
};

const sortAsc = (data, key) => {
  return data.sort((a, b) => {
    return new Date(a[key]) - new Date(b[key]);
  });
};
export const assignDoctorAccess = [
  "operations",
  "admin",
  "super_admin",
  "doctor_admin",
  "dispatch",
];

export const autoAssignDoctorRoles = [
  "doctor",
  "doctor_admin",
  "operations",
  "dispatch",
];

export const disableAssignDoctorStatus = [
  "delivered",
  "shipped",
  "shipping_pending",
  "void",
];

export const invalidStatuses = new Set(["void", "unknown"]);

/**
 * Calculate the number of valid (non-void, non-unknown) orders
 * @param {Array} orders - Array of order objects
 * @returns {number} Count of valid orders
 */
export const getValidOrderCount = (orders) => {
  if (!Array.isArray(orders)) return 0;
  if (orders.length < 1) return 0;

  const invalidOrders = orders.filter((item) => invalidStatuses.has(item.status));
  return orders.length - invalidOrders.length;
};

export const customDiscountAndZeroValueOrderEmails = [
  "nirbhay@traya.health", //For Prod testing
  "nirbhay@trayahealth.com",//For dev testing
  "agarwalsandip@traya.health",
  "vinayshinde@traya.health",
  "venugopal@traya.health",
  "abhishekbadhe@traya.health",
  "omkarsanas@traya.health",
  "listonthomas@traya.health",
  "nikhilsavant@traya.health"
];
export const findRelatedMedUser = (medReps, searchValue) => {
  return medReps?.userRole?.filter((user) =>
    user?.user?.first_name.toLowerCase().includes(searchValue)
  );
};

export function calculateSkus(productsData, comboProductMappings) {
  return (
    Array.isArray(productsData) &&
    productsData
      ?.filter((item) => !comboProductMappings.includes(item?.id))
      .map((item) => ({
        value: item?.id,
        label: item?.medicine?.medicine_short_name
          ? item?.medicine?.medicine_short_name
          : item?.medicine?.display_name,
      }))
  );
}

export function filterAndMapWarehouses(wareHousesData, requiredWarehouses) {
  const modifiedWareHousesData = wareHousesData.filter((item) => {
    const code = item?.code;
    return requiredWarehouses[code];
  });

  return modifiedWareHousesData.map((item) => ({
    value: item.id,
    label: item.name,
  }));
}
export function filterAndSetData(
  data,
  selectedAgent,
  selectedTempAgent,
  active,
  setSortData,
  newPage,
  lagger = null
) {
  let filteredData = data?.engagements || [];

  if (lagger === true || lagger === false) {
    filteredData = filteredData.filter((item) => lagger === item?.lagger);
  }

  if (selectedAgent.length > 0) {
    let agents = selectedAgent.map((item) => item.value);
    filteredData = filteredData.filter((item) =>
      agents.includes(item.rep.first_name)
    );
  }

  if (selectedTempAgent.length > 0) {
    let agents = selectedTempAgent.map((item) => item.value);
    filteredData = filteredData.filter((item) =>
      agents.includes(item?.tempRep?.first_name)
    );
  }
  if (!isEmpty(active)) {
    filteredData = filteredData.filter((slot) => active === slot?.status);
  }

  if (selectedAgent.length === 0 && lagger === null && active === null) {
    filteredData = data?.engagements || [];
  }

  setSortData(filteredData);
  newPage(1);
}

export const ticketResolvedAccess = [
  "sindhu@traya.health",
  "shraddhapawar@traya.health",
  "aakashbhatia@traya.health",
  "vaibhavghag@traya.health",
  "teasdhoiphodeda@traya.health",
  "agarwalsandip@traya.health",
  "tejasdoiphode@traya.health",
  "aurangzebkhan@traya.health",
  "silpapillai@trayahealth.com",
  "ibrahimkhan@traya.health",
  "darshanakadam@traya.health",
  "tejasgaikwad@traya.health",
  "silpapillai@traya.health",
  "shreyasparakal@traya.health",
  "amitgupta@traya.health",
  "ajinkyabandiwadekar@traya.health",
];

export const allowPaymentIssueTicketResolve = ["finance.tickets@traya.health"];

export const voitekkAcess = [
  "super_admin",
  "admin",
  "medical_rep",
  "sales_rep",
  "dispatch",
  "operations",
  "doctor_admin",
  "ivr_agent",
  "operations_admin",
  "medical",
  "support",
  "team_lead",
  "lead_agent",
];

const duration = moment().toDate();
duration.setHours(0);
duration.setMinutes(0);
duration.setSeconds(0);
duration.setMilliseconds(0);

const engagements = (engagement) =>
  engagement.map((el) => {
    const obj = { ...el };
    let attempts = el?.activity ? el?.activity?.attempts : [];
    attempts.sort((a, b) => b?.attempt_count - a?.attempt_count);
    attempts = attempts?.map((atm) => ({
      ...atm,
      attempt_start: atm?.attempt_start
        ? moment(atm?.attempt_start).format("YYYY-MM-DD HH:mm:ss")
        : "",
      attempt_end: atm?.attempt_end
        ? moment(atm?.attempt_end).format("YYYY-MM-DD HH:mm:ss")
        : "",
      // attempt_duration: atm?.attempt_duration
      //   ? `${moment(duration)
      //       .add(atm?.attempt_duration, "seconds")
      //       .format("HH:mm:ss")} hrs`
      //   : "",
      attempt_duration:
        (atm?.exotel_attempt_details?.total_talktime ||
          atm?.attempt_duration) &&
        atm?.attempt_info?.status === "answered"
          ? `${moment
              .utc(
                Number(
                  atm?.exotel_attempt_details?.total_talktime ||
                    atm?.attempt_duration
                ) * 1000
              )
              .format("HH:mm:ss")} hrs`
          : 0,
    }));

    if (!isEmpty(attempts)) {
      obj["call_started"] = attempts[attempts?.length - 1]?.attempt_start;
      obj["call_ended"] = attempts[attempts?.length - 1]?.attempt_end;
      obj["call_duration"] = attempts[attempts?.length - 1]?.attempt_duration;
      obj["activity"] = {
        ...el?.activity,
        attempts: attempts,
      };
      attempts?.forEach((atm) => {
        obj[`attempt_${atm?.attempt_count}`] = atm;
      });
    }
    obj["answered"] = attempts?.length
      ? attempts[attempts?.length - 1]?.attempt_info?.status
      : el?.notes?.includes("unanswered")
      ? "Unanswered"
      : el?.notes?.includes("answered")
      ? "Answered"
      : "";
    return obj;
  });

export const engagementReportDownload = async (
  sortData,
  setDownloadSign,
  tag
) => {
  const excelData = await engagements(sortData);
  const _data = excelData?.map((el) => {
    return {
      ...el,
      repName: el?.rep ? el.rep?.first_name : "",
      repEmail: el?.rep ? el.rep?.email : "",
      userName: el?.user ? el.user?.first_name : "",
      tempName: el?.tempRep ? el.tempRep?.first_name : "",
      tempEmail: el?.tempRep ? el.tempRep?.email : "",
      tag: el?.tag ? el?.tag : " ",
      answered: el?.answered ? el?.answered : " ",
      userPhone: el?.user ? el.user?.phone_number : "",
      reminder_date: el?.reminder_date
        ? moment(el?.reminder_date).format("YYYY-MM-DD HH:mm:ss")
        : "",
      call_ended: el?.call_ended
        ? moment(el?.call_ended).format("YYYY-MM-DD HH:mm:ss")
        : "",
      call_started: el?.call_started
        ? moment(el?.call_started).format("YYYY-MM-DD HH:mm:ss")
        : "",
      updatedAt: moment(el?.updatedAt).format("YYYY-MM-DD HH:mm:ss"),
      createdAt: moment(el?.createdAt).format("YYYY-MM-DD HH:mm:ss"),
      attempt_1: el?.attempt_1
        ? JSON.stringify(el?.attempt_1, undefined, 2)
        : "",
      attempt_2: el?.attempt_2
        ? JSON.stringify(el?.attempt_2, undefined, 2)
        : "",
      attempt_3: el?.attempt_3
        ? JSON.stringify(el?.attempt_3, undefined, 2)
        : "",
      attempt_4: el?.attempt_4
        ? JSON.stringify(el?.attempt_4, undefined, 2)
        : "",
      attempt_5: el?.attempt_5
        ? JSON.stringify(el?.attempt_5, undefined, 2)
        : "",
    };
  });

  const data = [
    {
      sheet: "Engagement Report",
      columns: [
        { label: "Agent Name", value: "repName" || " " },
        { label: "Agent Email", value: "repEmail" || " " },
        { label: "Temporary Agent Name", value: "tempName" || " " },
        { label: "Temporary Agent Email", value: "tempEmail" || " " },
        { label: "Customer Name", value: "userName" || " " },
        { label: "Customer Phone", value: "userPhone" || " " },
        { label: "Scheduled At", value: "reminder_date" || " " },
        { label: "Status", value: "status" || " " },
        { label: "Tag", value: "tag" || " " },
        { label: "Answered", value: "answered" || " " },
        { label: "Call started", value: "call_started" || " " },
        { label: "Call ended", value: "call_ended" || " " },
        { label: "Call duration", value: "call_duration" || " " },
        { label: "Notes", value: "notes" || " " },
        { label: "Created at", value: "createdAt" || " " },
        { label: "Last Updated", value: "updatedAt" || " " },
        { label: "Attempt 1", value: "attempt_1" || " " },
        { label: "Attempt 2", value: "attempt_2" || " " },
        { label: "Attempt 3", value: "attempt_3" || " " },
        { label: "Attempt 4", value: "attempt_4" || " " },
        { label: "Attempt 5", value: "attempt_5" || " " },
      ],
      content: _data,
    },
  ];
  let settings = {
    fileName: `Engagements Reports ${tag}`,
    extraLength: 3,
    writeMode: "writeFile",
    writeOptions: {},
  };
  xlsx(data, settings);
  setDownloadSign(false);
};

export const prescriptionAgentCheck = [
  "admin",
  "doctor_admin",
  "doctor",
  "dispatch",
  "support",
  "team_lead",
  "read_only",
  "medical_rep",
  "ivr",
  "consult_rep",
  "operations",
  "super_admin",
  "clinic_doctor"
];

export const assignDoctorCheck = [
  "admin",
  "doctor_admin",
  "dispatch",
  "support",
  "team_lead",
  "read_only",
  "medical_rep",
  "medrep_ext",
  "ivr",
  "consult_rep",
  "operations",
  "super_admin",
];

export const engagementSlot = [
  "medrep_ext",
  "medical_rep",
  "ivr",
  "operations",
];

// Get doctor signature URL from CDN
export const getDoctorSignatureUrl = (doctorName) => {
  if (!doctorName) return null;

  // Convert "Dr Ankita Shukla" to "Dr_Ankita_Shukla.png"
  const fileName = doctorName.replace(/\s+/g, "_") + ".png";

  return `${CDN_BASE_URL}doctor_signature/${fileName}`;
};

// Helper function to fetch image as base64 (for html2canvas compatibility)
export const fetchImageAsBase64 = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) return null;
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Failed to fetch doctor signature:', error);
    return null;
  }
};

// export const doctorFooterMap = {
//   "Dr Harish Balaji": Dr_Harish_Balaji,
//   "Dr Aakanksha Gupta": Dr_Aakanksha_Gupta,
//   "Dr Siddhi Sonawane": Dr_Siddhi_Sonawane,
//   "Dr Kalyani Deshmukh": Dr_Kalyani_Deshmukh,
//   "Dr Shefali Saini": Dr_Shefali_Saini,
//   "Dr Dhwani Saxena": Dr_Dhwani_Saxena,
//   "Dr Shailendra": Dr_Shailendra,
//   "Dr Komal Rathi": Dr_Komal_Rathi,
//   "Dr Vandana Verma": Dr_Vandana_Verma,
//   "Dr Divya Poulose": Dr_Divya_Poulose,
//   "Dr Sonal Makhija": Dr_Sonal_Makhija,
//   "Dr Sonia Tekchandani": Dr_Sonia_Tekchandani,
//   "Dr Shreya Deoghare": Dr_Shreya_Deoghare,
//   "Dr Rashi Soni": Dr_Rashi_Soni,
//   "Dr Shweta Tripathi": Dr_Shweta_Tripathi,
//   "Dr Aarushi Mittal": Dr_Aarushi_Mittal,
//   "Dr Pawan Singh": Dr_Pawan_singh,
//   "Dr Divyashree R": divya_shree,
//   "Dr Shriya saha": shriya,
//   "Dr Divyesh Jain": divyesh_jain,
//   "Dr Ramoli Nimbalkar": Ramoli_Nimbalkar,
//   "Dr Harshal": harshal_petkar,
//   "Dr Jessica Dodani": jsesica,
//   "Dr Reena Majithia": Dr_Reena_Majithia,
//   "Dr Avtarsinh Vaghela": Dr_Avtarsinh_Vaghela,
//   "Dr Vijayalaxmi": Dr_Vijayalaxmi,
//   "Dr Ritu Parna": Dr_Ritu,
//   "Dr Deepak Naik": Dr_Deepak,
//   "Dr Rajkumar Pal": Dr_Rajpal,
//   "Dr Shama Naaz": Dr_shama_naaz,
//   "Dr Keerti": Dr_Kreeti,
//   "Dr Asna Hassan": Dr_Asna_Hassan,
//   "Dr Chintaman Suvarna": Dr_Chintaman_Suvarna,
//   "Dr Nandini Shetty": Dr_Nandini_Shetty,
//   "Dr Haarika Sadhu": Dr_Haarika_Sadhu,
//   "Dr Sukrutha": Dr_Sukrutha,
//   "Dr Manali": Dr_Manali,
//   "Dr Manish": Dr_Manish,
//   "Dr Mariya": Dr_Mariya,
//   "Dr Siddhi": Dr_sidhi,
//   "Dr Ketaki": Dr_Ketaki,
//   "Dr Darshana_ayurveda": Dr_Darshana_Kulkarni,
//   "Dr Afreen Sayyed_ayurveda": Dr_Afreen_Sayyed,
//   "Dr Oshin Rajeev_ayurveda": Dr_Oshin_Rajeev,
//   "Dr Aisha Parveen": Dr_Aisha_Parveen,
//   "Dr Deepika Jain": Dr_Deepika_Jain,
//   "Dr Sharan Keshetty": Dr_Sharan_Keshetty,
//   "Dr Shashank Dhatwalia": Dr_Shashank_Dhatwalia,
//   "Dr Shivani Dawas": Dr_Shivani_Dawas,
//   "Dr Suhasini Goyal": Dr_Suhasini_Goyal,
//   "Dr Swapnil Hippargi": Dr_Swapnil_Hippargi,
//   "Dr Atul Soni": Dr_Atul_Soni,
//   "Dr Minakshi Bisen": Dr_Minakshi_Bisen,
//   "Dr Sakshi": Dr_Sakshi,
//   "Dr Deepali Rai": Dr_Deepali_Rai,
//   "Dr Devyani Baunthiyal": Dr_Devyani_Baunthiyal,
//   "Dr Jaineet Dhillon": Dr_Jaineet_Dhillon,
//   "Dr Pratima Majgaonkar": Dr_Pratima_Majgaonkar,
//   "Dr Vishali Vasu": Dr_Vishali_Vasu,
//   "Dr Anamika Thakur": Dr_Anamika_Thakur,
//   "Dr Dhriti Sood": Dr_Dhriti_Sood,
//   "Dr Lakshmi Somu": Dr_Lakshmi_Somu,
//   "Dr Priyanka Soni": Dr_Priyanka_Soni,
//   "Dr Sushmita Singh": Dr_Sushmita_Singh,
//   "Dr Yashvi Doshi": Dr_Yashvi_Doshi,
//   "Dr Aayushi": Dr_Aayushi,
//   "Dr Aditi": Dr_Aditi,
//   "Dr Kishan": Dr_Kishan,
//   "Dr Mehak": Dr_Mehak,
//   "Dr Pavan": Dr_Pavan,
//   "Dr Pranjali": Dr_Pranjali,
//   "Dr Sasi": Dr_Sasi,
//   "Dr Tanmay Badlawala":  Dr_Tanmay_Badlawala,
//   "Dr Anshita Mishra": Dr_Anshita_Mishra,
//   "Dr Mahima Chaudhary":  Dr_Mahima_Chaudhary,
//   "Dr Shreya Rawat":  Dr_Shreya_Rawat,
//   "Dr Shiv Singh Shekhawat":  Dr_Shiv_Singh_Shekhawat,
//   "Dr Amaan Kapadia": Dr_Amaan_Kapadia,
//   "Dr Aryan Babbar": Dr_Aryan_Babbar,
//   "Dr Anshika Verma": Dr_Anshika_Verma,
//   "Dr Madhuri Prasad": Dr_Madhuri_Prasad,
//   "Dr Siddhi Bhartiya": Dr_Siddhi_Bhartiya,
//   "Dr Yash Choudhary": Dr_Yash_Choudhary,
//   "Dr Snehal Devendra Yadav": Dr_Snehal_Devendra_Yadav,
//   "Dr Astha Pathak": Dr_Astha_Pathak,
//   "Dr Alisha": Dr_Alisha,
//   "Dr Shikhar": Dr_Shikhar,
//   "Dr Ankita Shukla": Dr_Ankita_Shukla,
//   "Dr Prachi": Dr_Prachi,
//   "Dr Sanjay Kumar": Dr_Sanjay_Kumar,
//   "Dr Vidhya": Dr_Vidhya,
//   "Dr Srinidhi Udayakumar": Dr_Srinidhi_Udayakumar,
//   "Dr Manish Raja": Dr_Manish_Raja,
//   "Dr Nikita Manocha": Dr_Nikita_Manocha,
//   "Dr Anisha Chauhan": Dr_Anisha_Chauhan,
//   "Dr Sabir Vasim Zariwala": Dr_Sabir_Vasim_Zariwala,
//   "Dr Prerna Giri": Dr_Prerna_Giri,
//   "Dr Shobha Gupta": Dr_Shobha_Gupta,
//   "Dr Srividhya Madira": Dr_Srividhya_Madira,
//   "Dr Swati Kaushal" : Dr_Swati_Kaushal,
//   "Dr Shiladitya Giri": Dr_Shiladitya_Giri,
//   "Dr Bagmita Mishra": Dr_Bagmita_Mishra,
//   "Dr Khushi Jeswani": Dr_Khushi_Jeswani,
//   "Dr Aswathy R": Dr_Aswathy_R,
//   "Dr Manpreet Singh": Dr_Manpreet_Singh,
//   "Dr Pooja Patel": Dr_Pooja_Patel,
//   "Dr Gaurav Raj": Dr_Gaurav_Raj,
//   "Dr Manisha Sharma" : Dr_Manisha_Sharma,
//   "Dr Itika Sharma": Dr_Itika_Sharma,
//   "Dr Muralii Krishna": Dr_Muralii_Krishna,
//   "Dr Puja Chaudhary": Dr_Puja_Chaudhari,
//   "Dr Ankita Bandgar": Dr_Ankita_Bandgar,
//   "Dr Shubham Sehrawat": Dr_Shubham_Sehrawat,
//   "Dr Noopur Chauhan": Dr_Noopur_Chauhan,
//   "Dr Sachita Bhaskar": Dr_Sachita_Bhaskar,
//   "Dr Shehraz Pasha": Dr_Shehraz_Pasha,
//   "Dr Shifa Kausar": Dr_Shifa_Kausar,
//   "Dr Mehak Aggarwal": Dr_Mehak_Aggarwal,
//   "Dr Monika Kanwar": Dr_Monika_Kanwar,
//   "Dr Paul MelkiSedhek": Dr_Paul_MelkiSedhek,
//   "Dr Deepa Boloor": Dr_Deepa_Boloor,
//   "Dr Anushka Rao": Dr_Anushka_Rao,
//   "Dr Rugved Dudhat": Dr_Rugved_Dudhat,
//   "Dr Dhwani Dipenkumar Maniar": Dr_Dhwani_Dipenkumar_Maniar,
//   "Dr Yogita Arya": Dr_Yogita_Arya,
//   "Dr Sakshi Omar": Dr_Sakshi_Omar,
//   "Dr Ankita Patil": Dr_Ankita_Patil,
//   "Dr Vishakha Sharma": Dr_Vishakha_Sharma,
//   "Dr Rakshita Rathore": Dr_Rakshita_Rathore,
//   "Dr Aditi Gupta": Dr_Aditi_Gupta,
//   "Dr Sauda Anjum": Dr_Sauda_Anjum,
//   "Dr Darshan Khosare": Dr_Darshan_Khosare,
//   "Dr Vrinda Sharma": Dr_Vrinda_Sharma,
//   "Dr Kriti Paul": Dr_Kriti_Paul,
//   "Dr Sakshi Singh": Dr_Sakshi_Singh,
//   "Dr Vaishnavi Adiga": Dr_Vaishnavi_Adiga,
//   "Dr Utkarsh Hatwar": Dr_Utkarsh_Hatwar,
//   "Dr Dhwani Haria": Dr_Dhwani_Haria,
//   "Dr Diksha Rani": Dr_Diksha_Rani,
//   "Dr Tanushree KN": Dr_Tanushree_KN,
//   "Dr Yashwanth Vodapalli": Dr_Yashwanth_Vodapalli,
//   "Dr Sanchit Sharma": Dr_Sanchit_Sharma,
//   "Dr Pritish Katara": Dr_Pritish_Katara,
//   "Dr Malasa Nayak": Dr_Malasa_Nayak,
//   "Dr Lipsa Patel": Dr_Lipsa_Patel,
//   "Dr Shrutika": Dr_Shrutika,
//   "Dr Shreya Raj": Dr_Shreya_Raj,
//   "Dr Diksha Sikariya": Dr_Diksha_Sikariya,
//   "Dr Mansi Vikhe": Dr_Mansi_Vikhe,
//   "Dr Garvit Kadian": Dr_Garvit_Kadian,
//   "Dr Shivangi Jaiswal": Dr_Shivangi_Jaiswal,
//   "Dr Ayush Bansal": Dr_Ayush_Bansal,
//   "Dr Bushra Aziz": Dr_Bushra_Aziz,
//   "Dr Maitri Pathak": Dr_Maitri_Pathak,
//   "Dr Bhumika Gupta": Dr_Bhumika_Gupta,
//   "Dr Vaishnavi Bodhe": Dr_Vaishnavi_Bodhe,
//   "Dr Vaishnavi Barde": Dr_Vaishnavi_Barde,
//   "Dr Prachi Sinha": Dr_Prachi_Sinha,
//   "Dr Chhavi Soni": Dr_Chhavi_Soni,
//   "Dr Samriti Soni": Dr_Samriti_Soni,
//   "Dr Anjali Tewari": Dr_Anjali_Tewari,
//   "Dr Ayushi Verma": Dr_Ayushi_Verma,
//   "Dr Sourabh Prashar": Dr_Sourabh_Prashar,
//   "Dr Akanksha Dhadich": Dr_Akanksha_Dhadich,
//   "Dr Pragati Panwar": Dr_Pragati_Panwar,
//   "Dr Tanya Kalra": Dr_Tanya_Kalra,
//   // "Dr Asritha Reddy": Dr_Asritha_Reddy,
//   "Dr Ankita Rahulkar": Dr_Ankita_Rahulkar,
//   "Dr Anuj Nautiyal": Dr_Anuj_Nautiyal,
//   "Dr Sana Peerzade": Dr_Sana_Peerzade,
//   "Dr Diksha Shrivastava": Dr_Diksha_Shrivastava,
//   "Dr Srushti Wankhede": Dr_Srushti_Wankhede,
//   "Dr Stuti Chandel": Dr_Stuti_Chandel,
//   "Dr Archie Rawat": Dr_Archie_Rawat,
//   "Dr Shivangi Patel": Dr_Shivangi_Patel,
//   "Dr Vikisa Sharma": Dr_Vikisa_Sharma,
//   "Dr Akanksha Sharma": Dr_Akanksha_Sharma,
//   "Dr Akansha Chauhan": Dr_Akansha_Chauhan,
//   "Dr Anushree Valasang": Dr_Anushree_Valasang,
//   "Dr Lakshmi PG": Dr_Lakshmi_PG,
//   "Dr Parvathy S": Dr_Parvathy_S,
//   "Dr Shruti Rai": Dr_Shruti_Rai,
//   "Dr Tejashree": Dr_Tejashree,
//   "Dr Chinmay Varma": Dr_Chinmay_Verma,
//   "Dr Mihika Bawankar": Dr_Mihika_Bawankar,
//   "Dr Nidhi Kaushik": Dr_Nidhi_Kaushik,
//   "Dr Shreyashee Saha": Dr_Shreyashee_Saha,
//   "Dr Stuti Kamdar": Dr_Stuti_Kamdar,
//   "Dr Vaidehi Thakur": Dr_Vaidehi_Thakur,
//   "Dr Aakanksha Pandey": Dr_Aakanksha_Pandey,
//   "Dr Anjaly KR": Dr_Anjaly_KR,
//   "Dr Asmi Sebastian": Dr_Asmi_Sebastian,
//   "Dr Priyanka R Shastry": Dr_Priyanka_R_Shastry,
//   "Dr Soujanya Kulakarni": Dr_Soujanya_Kulakarni,
//   // "Dr Chinmaiyee Bharadwaj": Dr_Chinmaiyee_Bharadwaj,
//   "Dr Nidiginti Thrinayani": Dr_Nidiginti_Thrinayani,
//   "Dr Ashna Jain": Dr_Ashna_Jain,
//   "Dr Reena Lendi": Dr_Reena_Lendi,
//   "Dr Yashita Singh": Dr_Yashita_Singh,
//   "Dr Sahana K": Dr_Sahana_K,
//   "Dr Stuti Jakhmola": Dr_Stuti_Jakhmola,
//   "Dr Vartika Khirwal": Dr_Vartika_Khirwal,
//   "Dr Deeksha Mishra": Dr_Deeksha_Mishra,
// };
export const QUAS_ENGAGEMENT = ["medrep_ext_ss"];
export const CNX_ENGAGEMENT = ["medrep_ext_cnx"];

export const engagementFilter = (engData, engTag) => {
  const today = moment();
  const tomorrow = moment(today).add(1, "days");

  return engData?.filter((item) => {
    const reminderDate = moment(item?.reminder_date);
    return engTag.includes(item?.tag) && reminderDate.isSameOrBefore(tomorrow);
  });
};

export const REVENUE_REP_ACCESS = ["medical_rep", "medrep_ext", "operations"];
export const DASHBOARD_HOME_ACCESS = [
  "consult_doctor",
  "doctor",
  "support",
  "team_lead",
  "sales",
];
export const DASHBOARD_ACTIONABLE_ROUTE = ["sales"];

export function createSortHandler(
  field,
  count,
  setCount,
  setSortData,
  setOpa,
  data
) {
  let order = "";
  switch (count) {
    case 0:
      order = "dsc";
      setCount(1);
      setSortData([
        ...data?.sort((a, b) => moment(a[field]) - moment(b[field])),
      ]);
      break;
    case 1:
      order = "asc";
      setCount(2);
      setSortData([
        ...data?.sort((a, b) => moment(b[field]) - moment(a[field])),
      ]);
      break;
    case 2:
      order = "";
      setCount(0);
      setSortData([...data]);
      break;
    default:
      break;
  }
  setOpa(order);
}

export const canWritePrescription = ["doctor", "doctor_admin", 'clinic_doctor'];

export const flaggedSubcategories = [
  "missing_product",
  "damaged_product",
  "mismatch_product",
];

export const productSelectionSubcategory = [
  "missing_product",
  "damaged_product",
  "mismatch_product",
  "reverse_pick_up",
];
export const requestTypeOption = [
  { label: "Replacement", value: "Replacement" }
];
export const requestTypeSubcategories = [
  "missing_product",
  "damaged_product",
  "mismatch_product",
];

export const withoutOrderidCategory = [
  "customer_complaints",
  "payments",
  "product_related_quality_issues",
  "tech_bugs",
];

export const formatDateAndTime = (timestamp) => {
  const date = new Date(timestamp);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;

  return formattedDate;
};
export const interventionAccess = [
  "medical",
  "admin",
  "support",
  "team_lead",
  "super_admin",
  "doctor_admin",
];

export const ADMIN_ACCESS = ["admin", "super_admin", "doctor_admin"];

export const COMMUNITY_ACCESS_EMAILS = [
  // clinic_receptionist only
  'manishanavale@traya.health',
  'moonclinic@gmail.com' // DEV testing
];

export const TOAST_MESSAGE_CSS = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

export const refundAccessOps = [
  "agarwalsandip@traya.health",
  "sindhu@traya.health",
  "nirajsurve@traya.health",
  "patilgaurang@traya.health",
  "superadmin@tenant.com",
  "anandkartik@traya.health",
  "shobha@traya.health",
  "finance.tickets@traya.health",
  "ibrahimkhan@traya.health",
  "shubham@trayahealth.com",
  "darshanakadam@traya.health",
  "shreyasparakal@traya.health",
  "amitgupta@traya.health",
  "listonthomas@traya.health",
  "venugopal@traya.health",
  "operations@traya.health"
];

export const instantRefundSubcategories = [
  "missing_product",
  "damaged_product",
  "mismatch_product",
  "reverse_pick_up",
  "return_request",
  "order_cancellation",
  "initiate_rto",
];

export const statusClassMap = {
  Available: "badge bg-primary fw-bold",
  Unavailable: "badge bg-dark fw-bold",
  Initiated: "badge bg-warning fw-bold",
  Successful: "badge bg-success fw-bold",
  Failed: "badge bg-danger fw-bold",
};

export const RETURN_REFUND_STATUSES = {
  REQUEST_RETURN: 1,
  APPROVE_RETURN: 2,
  REFUND: 3,
  CLOSE_RETURN: 4,
  PARTIALLY_REFUND: 5,
};

export const statusDescriptions = {
  [RETURN_REFUND_STATUSES.REQUEST_RETURN]: "Request Return",
  [RETURN_REFUND_STATUSES.APPROVE_RETURN]: "Approve Return",
  [RETURN_REFUND_STATUSES.REFUND]: "Refunded",
  [RETURN_REFUND_STATUSES.CLOSE_RETURN]: "Close Return",
  [RETURN_REFUND_STATUSES.PARTIALLY_REFUND]: "Partially Refunded",
};

export const userGroupAccess = ["00000000-0000-0000-0000-000000000019"];

export const getTatFormatedDate = (date) => {
  return date
    ? moment().add(date, "hours").format("MMM DD YYYY, hh:mm A")
    : moment().add(2, "days").format("MMM DD YYYY, hh:mm A");
};

export const allTicketsAccess = [
  "admin",
  "operations_admin",
  "doctor_admin",
  "super_admin",
  "medical",
];

export const currentUser = getCurrentUserRole();

export const userCanEdit = ["admin", "super_admin", "team_lead"];
export const userLevelCanEdit = ["4", "5"];

export const customLeadDiscount = [
  "agarwalsandip@traya.health",
  "aniketsingh@trayahealth.com",
  "atharvakamat@trayahealth.com",
  "kajaljaiswal@trayahealth.com",
  "hridayasawant@tatvarthahealth.com",
  "hrishiskesh@trayahealth.com",
  "aryakumbhar@trayahealth.co",
  "shifashaikh@tatvarthahealth.com",
  "shobha@traya.health",
  "nirbhay@trayahealth.com",
  "dhanshri@tatvarthahealth.com",
  "afiyashaikh@tatvarthahealth.com",
  "shwetapandey@tatvarthahealth.com",
  "irfangaffar@tatvarthahealth.com",
  "kartavyabajpay@tatvarthahealth.com",
  "roshnisingh@trayahealth.com",
  "yuktagoday@tatvarthahealth.com",
  "pawanparab@tatvarthahealth.com",
  "yashvipawar@tatvarthahealth.com",
  "krishnamishra@tatvarthahealth.com",
  "mehrajshah@tatvarthahealth.com",
  "laxmisinge@tatvarthahealth.com",
  "manthankasare@tatvarthahealth.com",
  "ayubmomin@tatvarthahealth.com",
  "mumtajshaikh@tatvarthahealth.com",
  "zaidalishaikh@tatvarthahealth.com",
  "satishpal@tatvarthahealth.com",
  "lancycastelino@tatvarthahealth.com",
  "nirajgupta@tatvarthahealth.com",
  "udaythurpati@tatvarthahealth.com",
  "rumaizaansari@tatvarthahealth.com",
  "gyanikashrivastav@tatvarthahealth.com",
  "chetansahu@tatvarthahealth.com",
  "shoaibsayyed@tatvarthahealth.com",
  "glancypinto@tatvarthahealth.com",
  "shakirshaikh@tatvarthahealth.com",
  "rahulbandal@tatvarthahealth.com",
  "saaydaansari@tatvarthahealth.com",
  "nidhisampat@tatvarthahealth.com",
  "suniskasantra@tatvarthahealth.com",
  "prashantchaudhary@tatvarthahealth.com",
  "nadimmalik@tatvarthahealth.com",
  "yashwantsingh@tatvarthahealth.com",
  "amanimtiyaz@tatvarthahealth.com",
  "pujabavaskar@tatvarthahealth.com",
  "ayanshaikh@tatvarthahealth.com",
  "raziyanai@tatvarthahealth.com",
  "shoebshaikh@tatvarthahealth.com",
  "chandshaikh@tatvarthahealth.com",
  "riya@trayahealth.com",
  "sajid@traya.health",
  "rashmi@traya.health",
  "seliyaabdul@traya.health",
  "pawanparab@traya.health",
  "manthankasare@traya.health",
  "rumaizaansari@traya.health",
  "ayubmomin@traya.health",
  "atharvakamat@traya.health",
  "irfangaffar@traya.health",
  "gyanikashrivastav@traya.health",
  "kajaljaiswal@traya.health",
  "krishnamishra@traya.health",
  "udaythurpati@traya.health",
  "shoebshaikh@traya.health",
  "pranalimayekar@traya.health",
  "sanjanaupadhaya@traya.health",
  "sheejalpandey@traya.health",
  "fairosshaikh@traya.health",
  "rehaanshaikh@traya.health",
];

const isValidVoitekk =
  Object.keys(voitekkUserIdMap).includes(secureLocalStorage.getItem("id")) ||
  (secureLocalStorage.getItem("voitekk_id") &&
    secureLocalStorage.getItem("voitekk_id") !== "null")
    ? true
    : false;
export const currentLevel = secureLocalStorage.getItem("level");
export const teamLeadUnmask = ([ROLES_NAME.TEAM_LEAD].includes(currentUser) && [4].includes(currentLevel));
export const supportLevelMask = ([ROLES_NAME.SUPPORT].includes(currentUser) && [3].includes(currentLevel));
export const medrepLevel2RetakeAccess = ([ROLES_NAME.MEDICAL_REP].includes(currentUser) && [2].includes(currentLevel));
export const isLevel3Doctor = () => {
  const currentRole = getCurrentUserRole();
  const currentLevelValue = Number(secureLocalStorage.getItem("level"));
  return doctor.includes(currentRole) && currentLevelValue === 3;
};
// Med rep (any level) or doctor level 3 — audience allowed to reschedule SLOT_BOOKING engagements
export const canRescheduleSlotBooking = () =>
  getCurrentUserRole() === ROLES_NAME.MEDICAL_REP || isLevel3Doctor();
export const isExternalMedrep =
  (THIRD_PARTY_MEDREPS.includes(getCurrentUserRole()) && !isValidVoitekk)
    ? true
    : false;

export const pincodeManagementAccess = [
  "shubham@trayahealth.com",
  "nirajsurve@traya.health",
  "tech@traya.health",
];

export const SHOPIFY_CANCEL = [
  "aakashbhatia@traya.health",
  "sindhu@traya.health",
  "agarwalsandip@traya.health",
  "aniket@traya.health",
  "vaibhavghag@traya.health",
  "shraddhapawar@traya.health",
  "aurangzebkhan@traya.health",
  "darshanakadam@traya.health",
  "ibrahimkhan@traya.health",
  "silpapillai@traya.health",
  "tejasdoiphode@traya.health",
  "shubham@trayahealth.com",
  "shreyasparakal@traya.health",
  "amitgupta@traya.health",
  "ajinkyabandiwadekar@traya.health",
  "venugopal@traya.health",
  "armankhan@traya.health"
];

export const engagementDateFilter = (engData) => {
  const today = moment().endOf("days");
  const tomorrow = moment(today).add(1, "days");
  return engData?.filter((item) => {
    const reminderDate = moment(item?.reminder_date);
    return reminderDate.isSameOrBefore(tomorrow);
  });
};

export const MEDREP_ENG_ACCESS = ["medical_rep"];

export const TEMP_ENG_ACCESS = [
  "00000000-0000-0000-0000-000000000002",
  "00000000-0000-0000-0000-000000000015",
  "00000000-0000-0000-0000-000000000013",
  "00000000-0000-0000-0000-000000000029",
  "00000000-0000-0000-0000-000000000028",
  "00000000-0000-0000-0000-000000000022",
  "00000000-0000-0000-0000-000000000032",
  "00000000-0000-0000-0000-000000000020",
  "00000000-0000-0000-0000-000000000008",
  "00000000-0000-0000-0000-000000000042",
];

export const filterOption = (input, option) =>
  (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

export const isDownloadDisabled = ![
  "omkar@traya.health",
  "aniket@traya.health",
  // "zahra@traya.health",
  "agarwalsandip@traya.health",
  // "tarayechaitali@traya.health",
  // "nirajsurve@traya.health",
  // "operations@trayahealth.com",
  // "agarwalharsh@traya.health",
  "nirbhay@traya.health",
  "nirbhay@trayahealth.com", // For dev checking
  "adarshchourasia@traya.health",
  "listonthomas@traya.health",
  // "sejalsawant@traya.health",
  // "finance.tickets@traya.health",
  "tarayechaitali@traya.health",
  "finance.tickets@traya.health",
  "ayushinagar@traya.health",
  "ayushraj@traya.health",
  "ashishsonavane@traya.health",
  "sayedasad@traya.health",
  "vikrammenon@traya.health",
  "muskansharma@traya.health",
  "navinkumar@traya.health"
].includes(secureLocalStorage.getItem("email"));

export const maskPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || phoneNumber.length < 4) return phoneNumber;

  const countryCodeMatch = phoneNumber.match(/^\+\d+/);
  const countryCode = countryCodeMatch ? countryCodeMatch[0] : "";
  const numberWithoutCode = countryCode ? phoneNumber.slice(countryCode.length) : phoneNumber;

  const visibleDigits = 4;
  const maskedPart = "*".repeat(Math.max(0, numberWithoutCode.length - visibleDigits));

  return `${countryCode}${maskedPart}${numberWithoutCode.slice(-visibleDigits)}`;
};

export const noSlotInMedicalEscalation = (subcategory) => {
  return [CATEGORY.MEDICAL_DOCUMENT].includes(subcategory);
};

export const knowlarityAccess = [
  "super_admin",
  "admin",
  "medical_rep",
  "sales_rep",
  "dispatch",
  "operations",
  "doctor_admin",
  "ivr_agent",
  "operations_admin",
  "medical",
  "support",
];

export const attemptStatus = [
  { label: "Zero", value: "less_than_zero" },
  { label: "Greater than Zero", value: "greater_than_zero" },
];

export function getFullName(user) {
  const firstName = get(user, 'first_name', '');
  const lastName = get(user, 'last_name', '');

  return compact([firstName, lastName]).join(' ');
}
export  const buildQueryString = (data) => {
  const params = new URLSearchParams();
  for (const key in data) {
    if (Array.isArray(data[key])) {
      const arrayString = `[${data[key].join(",")}]`;
      params.append(key, arrayString);
    } else if (data[key] !== undefined && data[key] !== "") {
      params.append(key, data[key]);
    } else {
      params.append(key, "");
    }
  }
  return `?${params.toString()}`;
};


export const filterAndTransformParams = (params) => {
  return Object.fromEntries(
    Object.entries(params)
      .filter(([key, value]) =>
        Array.isArray(value) ? value.length > 0 : value
      )
      .map(([key, value]) => [
        key,
        Array.isArray(value) ? JSON.stringify(value) : value,
      ])
  );
};

export const ERROR_MESSAGES = {
  SWW: "Something went wrong"
};

export const CALL_PROVIDERS = {
  KNOWLARITY_V1 : 'KNOWLARITY_V1',
  AMEYO: 'AMEYO',
  AGAMI: 'AGAMI',
  UBONA: 'UBONA',
  PLIVO: 'PLIVO',
}
export function getJsonFromSecureLocalStorage(key) {
  try {
      const item = secureLocalStorage.getItem(key);
      if (item) {
          return JSON.parse(item);
      }
      return null;
  } catch (error) {
      console.error(`Error parsing JSON from getJsonFromSecureLocalStorage for key "${key}":`, error);
      return null;
  }
}

export function getCustomerPhoneNumberByPhoneType(
  customerData = {},
  phoneType = "phone"
) {
  const phoneTypeFields = {
    phone: isExternalMedrep ? "phone_number_hash" : "phone_number",
    alternatePhone: isExternalMedrep ? "alternate_phone_hash" : "alternate_phone",
    chat: isExternalMedrep ? "chat_phone_number_hash" : "chat_phone_number"
  };

  const fieldName = phoneTypeFields[phoneType];

  return fieldName ? get(customerData, ["user", fieldName]) || "" : "";
};

export const CLINIC_DOCTOR_FLAG = ["clinic_doctor"].includes(currentUser);

export const PRESCRIPTION_TEST = [
  "CBC",
  "TSH",
  "S. FERRITIN",
  "S. VIT D",
  "S. VIT B12",
  "LFT",
  "RFT with Serum Electrolytes",
  "Lipid Profile"
];

export const CUSTOM_DISCOUNT_EMAIL = [
  "nirbhay@traya.health",
  "agarwalsandip@traya.health",
  "vinayshinde@traya.health",
  "venugopal@traya.health",
  "listonthomas@traya.health"
];

export const MISLANEOUS_ORDER = ![
  "operations@traya.health",
  "nirajsurve@traya.health",
  "vikrammenon@traya.health"
].includes(secureLocalStorage.getItem("email"));

export const CREATE_NEW_USER_EMAIL_ACCESS = [
  "sejalsawant@traya.health",
  "listonthomas@traya.health",
  "chariavi@traya.health"
].includes(secureLocalStorage.getItem("email"));

export const TECH_TICKET_ACCESS = [
  'arjumanshaikh@traya.health',
  "nirbhay@trayahealth.com",
  "saddambelavi@traya.health",
  "venugopal@traya.health",
  "arshishaikh@traya.health"
].includes(secureLocalStorage.getItem("email"));

export const ALL_ORDER_PLACE_FLAG = [
  "sindhu@traya.health",
  "vinayshinde@traya.health",
  "nirbhay@traya.health",// For dev testing
  "abhishekbadhe@traya.health"
].includes(secureLocalStorage.getItem("email"));

export const ENG_REP_DOWN = ![
  "hritvikpatwa@traya.health",
  "mansooriarshad@traya.health",
  "clinton@traya.health",
  "rameez@traya.health",
  "sayedasad@traya.health",
  "rajeshyadav@traya.health",
  "omkar@traya.health",
  "muskansharma@traya.health"
].includes(secureLocalStorage.getItem("email"));

export const TEAM = {
  ADMIN: 'Admin',
  ADMINISTRATION: 'Administration',
  ANALYTICS: 'Analytics',
  BRAND: 'Brand',
  CALLING: 'Calling',
  CHAT: 'Chat',
  COMMUNITY: 'community',
  COMPLAINTS: 'Complaints',
  CONTENT: 'Content',
  CX_COMPLAINTS: 'Cx complaints',
  DOCTOR: 'Doctor',
  E_COMMERCE: 'E-Commerce',
  FINANCE: 'Finance',
  GROWTH_MARKETING: 'Growth Marketing',
  HAIR_TRANSPLANT: 'Hair Transplant',
  HUMAN_RESOURCES: 'Human Resources',
  MARKETING: 'Marketing',
  MEDICAL: 'Medical',
  MEDICAL_ESCALATION: 'Medical escalation',
  NEW_PRODUCT_DEVELOPMENT: 'New Product Development',
  OD: 'OD',
  OFFLINE_DEPARTMENT: 'Offline Department',
  OJT: 'OJT',
  OPERATIONS: 'Operations',
  PR_COMMUNICATION: 'PR & Communication',
  PRODUCT_MANAGEMENT: 'Product Management',
  QUALITY: 'Quality',
  SALES: 'Sales',
  TECH: 'TECH',
  TRAINING: 'Training',
  UNDER_TRAINING: 'Under training'
};


export const QA_QUESTIONS_ACCESS = [
  "shubham@trayahealth.com", //dev testing(super admin)
  "arjuntest@gmail.com", //dev testing(admin)
  "bharathputta@traya.health",
];

export const DC_OPTION = [
  { label: "Doctor Booking", value: "doctor" },
  { label: "Coach Booking", value: "coach" },
]
export const DOCTOR_BOOKING_FLAG  = ['dr.sharan@traya.health'].includes(secureLocalStorage.getItem("email"));
export const MTD_REPORT_ACCESS  = [
  'nirbhay@traya.health', //prod testing
  'nirbhay@trayahealth.com', // dev testing
  "agarwalsandip@traya.health",
  "aniket@traya.health",
  "mishraankur@traya.health",
  "altaf@traya.health",
  "omkar@traya.health",
  "sulakshana@traya.health",
  "lakshikakothari@traya.health",
  "saloni@traya.health",
  "tejas@traya.health",
  "aartikhadka@traya.health"
 ].includes(secureLocalStorage.getItem("email"));

export const SALES_DASHBOARD_ACCESS = [
  'rajannogamiya@traya.health',
  'nirbhay@trayahealth.com', // dev testing
 ].includes(secureLocalStorage.getItem("email"));

export const CONVIN_DASHBOARD_ACCESS = [
  'ayushraj@traya.health',
  'rohit@traya.health',
  'suyash@traya.health'
].includes(secureLocalStorage.getItem("email"));

export const CALL_DASHBOARD_ACCESS = [
  'ayushraj@traya.health',
].includes(secureLocalStorage.getItem("email"));

export const OTS_DELHIVERY_ACCESS = [
  'tamannaagarwal@traya.health',
  'khanmahvish@traya.health',
].includes(secureLocalStorage.getItem("email"));

export const AUTO_QA_DASHBOARD_ACCESS = [
  'ayushraj@traya.health',
  'rohit@traya.health',
  'suyash@traya.health',
  'singhmanisha@traya.health',
  'adetichakraborty@traya.health',
  'priya@traya.health',
  'paiakshata@traya.health',
  'idrisitayyab@traya.health',
  'qureshinabila@traya.health',
  'shrishtigupta@traya.health',
  'maheshwaripriyanka@traya.health',
  'akhiltripathi@traya.health',
  'deepalisunilnalawade@traya.health',
].includes(secureLocalStorage.getItem("email"));

export const KPI_DASHBOARD_ACCESS = [
  'aysha@traya.health',
  'alimohammadlakhani@traya.health',
  'neelampathak@traya.health',
  'afiyashaikh@traya.health',
  'laxmisinge@traya.health',
  'priyankasingh@traya.health',
  'vaibhavghag@traya.health',
  'riddhiahir@traya.health',
  'prashantsalunkhe@traya.health',
  'rinaldobarnes@traya.health',
  'prapti@traya.health',
  'sauravdas@traya.health',
  'tausifshah@traya.health',
  'akshadakamble@traya.health',
  'kainathsiddiqui@traya.health',
  'gauriargulwar@traya.health',
  'nazneenkhan@traya.health',
  'shaistakhan@traya.health',
  'vaqasahmed@traya.health',
  'fahadkhan@traya.health',
  'monikanojiya@traya.health',
  'anas@traya.health',
  'tabashirakhan@traya.health',
  'joshuafranklin@traya.health',
  'snehaltambe@traya.health',
  'deepalisunilnalawade@traya.health',
  'srikanthreddy@traya.health',
  'vinodkumar@traya.health',
  'gadhavevaidehi@traya.health',
  'sanjaysuthar@traya.health',
  'aayushraj@traya.health',
].includes(secureLocalStorage.getItem("email"));

export const CLINIC_RECEPTIONINST_FLAG = [ROLES_NAME.CLINIC_EXECUTIVE, ROLES_NAME.CLINIC_RECEPTIONIST].includes(currentUser);

export const OFFLINE_STORE = async () => {
  const result = {};
  try {
    const res = await getStoreList();
    const storeInfo = res?.data?.clinics;
    if (storeInfo) {
      storeInfo.forEach((item) => {
        result[item.clinic_id] = item.clinic_name;
      });
    }
  } catch (err) {
    toast.error(err?.response?.data?.message);
  }
  return result;
};

export const getRefundStatus = async (orderID) => {
  try {
    const response = await getRefundStatusData(orderID);
    return response.data;
  } catch (error) {
    console.error("Error fetching order refund status:", error);
    return false;
  }
};

export const SMART_ASSIST_ACCESS = [
  'Aditya.Varma@corp.fusionbposervices.com',
  'Sayyed.Afroz@corp.fusionbposervices.com',
  'Akash.Tiwari@corp.fusionbposervices.com',
  //prod testing
  'vanshulkesharwani@traya.health',
  'ashishsonavane@traya.health',
  'agarwalsandip@traya.health',
  'mishraankur@traya.health',
  'nikhilnayak@traya.health',
  'arjungowda@traya.health',
  'omkar@traya.health',
];
 export const IS_DOCTOR = ['consult_doctor', 'doctor'];
 export const LEAD_AGENT_ACTIONABLE_FLAG = [
  "abdulmiqaeel.mulla@technotask.co.in",
  "mohammadsamit.kokate@technotask.co.in",
  "rupa.dhane@technotask.co.in",
  "anisha.rajbhar@technotask.co.in",
  "nisha.sutar@technotask.co.in",
  "rahul.nayak@technotask.co.in",
  "urmi.vora@technotask.co.in",
  "siddhant.more@technotask.co.in",
  "akash.tirupati@technotask.co.in",
  "ashutosh.kamble@technotask.co.in",
  "joha.wasgare@technotask.co.in",
  "anuj.gupta@technotask.co.in",
  "akash.bhavi@technotask.co.in",
  "rudraksh.kedar@technotask.co.in"
 ].includes(secureLocalStorage.getItem('email'));

 export const POST_SALES_FLAG = [
  "adnan.shaikh@corp.fusionbposervices.com",
  "amina.shaikh@corp.fusionbposervices.com",
  "Eram.Khan@corp.fusionbposervices.com",
  "Sajida.Shaikh@corp.fusionbposervices.com",
  "Afreen.Khan@corp.fusionbposervices.com",
  "danish.khan@corp.fusionbposervices.com",
  "Sayyed.Afroz@corp.fusionbposervices.com",
  "Amit.Singh@corp.fusionbposervices.com",
  "Muskaan.mandlekar@corp.fusionbposervices.com",
  "Alisha.mansuri@corp.fusionbposervices.com",
  "Fazila.Shaikh@corp.fusionbposervices.com",
  "vishal.kamble@corp.fusionbposervices.com",
  "Talat.Ansari@fusioncx.org",
  "Mansi.Gaware@fusioncx.org",
  "ranjita.dupare@corp.fusionbposervices.com",
  "Aditi.tandel@corp.fusionbposervices.com",
  "idrisi.Farhan@corp.fusionbposervices.com",
  "Akash.Sharma@corp.fusionbpos",
  "Afsana.sayyed@corp.fusionbposervices.com",
  "ashwini.sangar@corp.fusionbposervices.com",
  "Rutuja.Washivale@fusioncx.org",
  "Vishal.Gupta@corp.fusionbposervices.com",
  "Rushikesh@fusioncx.org",
  "Aayushi.Anil@fusioncx.org",
  "Afrin.Mujawar@corp.fusionbposervices.com",
  "Shaikh.zuhair@fusioncx.org",
  "Shalaka.Shere@fusioncx.org",
  "Jasira.Nawade@fusioncx.org",
  "Sakshi.Maidargi@fusioncx.org",
  "Sonam.Gupta@fusioncx.org",
  "Pradnya.kamble@fusioncx.org",
  "Roshni.Gupta@fusioncx.org",
  "Shraddha.Padave@fusioncx.org",
  "Shaikh.Saif@fusioncx.org",
  "Sameer@fusioncx.org",
  "Faiyaz.Ahmed@fusioncx.org",
  "Ayesha.Shaikh@fusioncx.org",
  "Mamta.rasaili@fusioncx.org",
  "shaziya.sayyed@fusioncx.org",
  "Sahil.Shaikh@corp.fusionbposervices.com",
  "Afrin.Shah@corp.fusionbposervices.com",
  "mohd.shaikh@fusioncx.org",
  "Shaikh.sahil@corp.fusionbposervices.com",
  "anushree.satam@corp.fusionbposervices.com",
  "siddhesh.lokhande@corp.fusionbposervices.com",
  "Shifa.Khan@fusioncx.org",
  "Sonali.Deshmukh@fusioncx.org",
  "Jayda.Siddiqui@fusioncx.org",
  "Ranjeet.Gupta@corp.fusionbposervices.com",
  "Suvarna.Das@fusioncx.org",
  "Aditya.Gaikwad@corp.fusionbposervices.com",
  "Priyanka.Yadav@corp.fusionbposervices.com",
  "ali.mushtaq@corp.fusionbposervices.com",
  "Samreen.Mulla@corp.fusionbposervices.com",
  "sayyad.babu@corp.fusionbposervices.com",
  "manisha.gupta@corp.fusionbposervices.com",
  "Neha.Sharma@corp.fusionbposervices.com",
  "Shweta.Mishra@corp.fusionbposervices.com",
  "Mayuri.Saindane@corp.fusionbposervices.com",
  "Tejaswini.Vatari@corp.fusionbposervices.com"
].includes(secureLocalStorage.getItem('email'));

export const DISABLE_ACTIONABLE_EMAILS = [
  "shakirshaikh@traya.health",
  "abhishekvishwakarma@traya.health",
  "vaishnavi.kedare@technotask.co.in",
  "faiz.khan@technotask.co.in",
].includes(secureLocalStorage.getItem('email'));

export const ENGAGEMENT_TAG_OPTIONS = [
  { key: 'Prescription Call', value: 'Prescription Call' },
  { key: 'Week #1', value: 'Week #1' },
  { key: 'Week #2', value: 'Week #2' },
  { key: 'Week #3', value: 'Week #3' },
  { key: 'Week #4', value: 'Week #4' },
  { key: 'Week #5', value: 'Week #5' },
  { key: 'Week #6', value: 'Week #6' },
  { key: 'retention', value: 'retention' },
  { key: 'SLOT_BOOKING', value: 'SLOT_BOOKING' },
  { key: 'IVR_BOOKING', value: 'IVR_BOOKING' },
  { key: 'FEEDBACK_CALL', value: 'FEEDBACK_CALL' },
  { key: 'ADHOC_CALL', value: 'ADHOC_CALL' },
  { key: 'w0_call', value: 'w0_call' },
  { key: 'Clinic Visit', value: 'CLINIC_VISIT' }
];

export const ENGAGEMENT_TAGS = {
  CONCERN_CALL: 'Concern Call',
  PRESCRIPTION_CALL: 'Prescription Call',
  RETENTION_CALL: 'retention',
  WEEK_1: 'Week #1',
  WEEK_2: 'Week #2',
  WEEK_3: 'Week #3',
  WEEK_4: 'Week #4',
  WEEK_5: 'Week #5',
  WEEK_6: 'Week #6',
  IVR_BOOKING: 'IVR_BOOKING',
  SLOT_BOOKING: 'SLOT_BOOKING',
  FEEDBACK_CALL: 'FEEDBACK_CALL',
  ADHOC_CALL: 'ADHOC_CALL',
  SLOT_BOOKING_MEDICAL: 'SLOT_BOOKING_MEDICAL',
  ABANDONED_CART: 'abandoned_cart',
  W0_CALL: 'w0_call',
  SCALPIE_UPDATE: 'scalpie_update',
  KIT_NOT_STARTED: 'kit_not_started',
  CUSTOMER_COMPLAINT_BOOKING: 'CUSTOMER_COMPLAINT_BOOKING',
  CHAT_SLOT_BOOKIG: 'chat_slot_booking',
  IVR_CALLBACK: 'IVR_CALLBACK',
  CLINIC_VISIT: 'CLINIC_VISIT',
  SCALP_TEST_REMINDER: 'SCALP_TEST_REMINDER',
  SCALP_TEST_RESCHEDULE: 'SCALP_TEST_RESCHEDULE',
  OFFLINE_DOCTOR_REMINDER: 'OFFLINE_DOCTOR_APPOINTMENT_REMINDER',
  OFFLINE_DOCTOR_RESCHEDULE: 'OFFLINE_DOCTOR_APPOINTMENT_RESCHEDULE',
  INLINE_CALL: 'INLINE_CALL',
};

export const EXTRA_ENGAGEMENT_TAGS = {
  ONBOARDING_CALL: 'Onboarding Call',
  SLOT_BOOKING_LEAD: 'Slot Booking Lead',
  CLINIC_SLOT: 'Clinic Slot'
}

export const COMMUNITY_OPTIONS = [
  'TS02KOTHRUD', 'TS03WAKAD', 'TS04PMC', 'TS05DPROAD', 'TSO6WANOWRIE'
];

export const getDecryptedData = (encryptData) => {
	try {
    const ENCRYPTION_SECRET_KEY='nfjaksrw42625wrfsb6u2bwtafskiar5'
		const bytes = CryptoJS.AES.decrypt(encryptData, ENCRYPTION_SECRET_KEY);
		return bytes.toString(CryptoJS.enc.Utf8);
	} catch (e) {
		console.error('getDecryptedData::', e);
		return null;
	}
};

export const engagementRequestTypeOptions = [
  { label: "App Booking", value: "app_booking" },
  { label: "Forced Slot", value: "forced_slot" },
  { label: "Website Booking", value: "website_booking" },
  { label: "Website Lead Booking", value: "website_lead_booking" },
  { label: "15 Day Coach Booking", value: "15day_coach_booking" },
  { label: "15 Day Coach Lead Booking", value: "15day_coach_lead_booking" },
  { label: "O1 Activation Call", value: "o1_activation_call" },
];

export const ivrTagOptions = [
  { label: "IVR Slot", value: "IVR_Slot" },
  { label: "IVR W1", value: "IVR_W1" },
  { label: "IVR W3", value: "IVR_W3" },
  { label: "IVR W0", value: "IVR_W0" },
  { label: "IVR Retention", value: "IVR_Retention" },
  { label: "IVR Prescription", value: "IVR_Prescription" },
  { label: "IVR Booking", value: "IVR_Booking" },
  { label: "IVR Concern", value: "IVR_Concern" },
  { label: "IVR Feedback", value: "IVR_Feedback" },
  { label: "IVR Adhoc", value: "IVR_Adhoc" },
  { label: "IVR Kit Not Started", value: "IVR_Kit_Not_Started" },
  { label: "IVR Scalpie", value: "IVR_Scalpie" },
  { label: "IVR Customer Complaint", value: "IVR_Customer_Complaint" },
];

export const LOCATIONS = [
  { key: "Thane", value: "Thane" },
  { key: "WFH", value: "WFH" },
  { key: "Malad", value: "Malad" },
  { key: "TechnoTask Mumbai", value: "TechnoTask Mumbai" },
  { key: "TechnoTask Bhopal", value: "TechnoTask Bhopal" },
  { key: "Kochar tech Amritsar", value: "Kochar tech Amritsar" },
  { key: "Fusion Kolkata", value: "Fusion Kolkata" },
  { key: "TechnoTask", value: "TechnoTask" },
  { key: "Voitek Mumbai", value: "Voitek Mumbai" },
  { key: "Malad ", value: "Malad " },
  { key: "CNX Mumbai", value: "CNX Mumbai" },
  { key: "Fusion Mumbai", value: "Fusion Mumbai" },
  { key: "Fusion kolkata", value: "Fusion kolkata" },
  { key: "Pune", value: "Pune" }
];


// Jun/25
export const isNewDispositionFeature = (engagement) => {
  return (
    [
      "Week #0",
      "Week #1",
      "Week #3",
      "retention",
      "abandoned_cart",
      "w0_call",
    ].includes(engagement?.tag) ||
    //Slot (Probeg) or level 1 and 3 reps
    (engagement?.tag === "SLOT_BOOKING" &&
      [1, 3].includes(engagement?.rep?.level))
  );
};

export const FORMULATION_PRODUCTS = [ "Hair Santulan 01", "Hair Santulan 02", "Hair Santulan 03", "Hair Ras 01", "Hair Ras 02", "Hair Ras 05", "Hair Ras 09", "Hair Ras 06"];

export const CUSTOMER_LANGUAGES = [
  { value: "tamil", label: "Tamil" },
  { value: "telugu", label: "Telugu" },
  { value: "kannada", label: "Kannada" },
  { value: "hindi", label: "Hindi" },
  { value: "english", label: "English" }
];

export const BLOCKED_ACCESS = [
  "super_admin"
].includes(currentUser);

// Emails allowed to bypass the ₹5000 cart value limit while placing COD orders
export const CART_LIMIT_BYPASS_EMAILS = [
  'nirajsurve@traya.health',
  'agarwalsandip@traya.health',
];

// Emails allowed to edit QA cluster prompts
export const QA_PROMPT_EDITOR_EMAILS = [
  'omkar@traya.health',
  'agarwalsandip@traya.health',
  'bharathputta@traya.health',
  'nirbhay@trayahealth.com',
  'suyash@traya.health',
  'priya@traya.health',
  'singhmanisha@traya.health',
  'akhiltripathi@traya.health',
  'deepalisunilnalawade@traya.health',
];
export const canEditQaPrompts = baseURL.API_URL_BASE.includes("dev") || QA_PROMPT_EDITOR_EMAILS.includes(secureLocalStorage.getItem('email'));

// QA template change-request approvers are no longer mirrored here.
// The list API (GET /qa-audit/template-change-requests) returns
// `caller_approver_levels` and the UI gates approve/reject from that —
// the backend remains the real gate (403).

export const QA_TEMPLATE_GROUPS_VIEW_EMAILS = [
  'rohit@traya.health',
  'suyash@traya.health',
];
export const QA_DOWNLOAD_EMAILS = [
  'suyash@traya.health',
];
export const canDownloadQaReports = QA_DOWNLOAD_EMAILS.includes(secureLocalStorage.getItem('email'));

export const canViewQaTemplateGroups = QA_TEMPLATE_GROUPS_VIEW_EMAILS.includes(secureLocalStorage.getItem('email'))
  || QA_PROMPT_EDITOR_EMAILS.includes(secureLocalStorage.getItem('email'));

export const STORE_VISIT_DOWNLOAD_EMAILS = [
  'sahil@traya.health',
  'aartikhadka@traya.health',
  'ashishsonavane@traya.health',
  'priyanshusinha@traya.health',
  'vanshulkesharwani@traya.health',
  'nirbhay@traya.health',
  'aartikhadka_store@gmail.com',
  'vikrantsavaratkar_store@gmail.com',
  'fazalmurtuza@traya.health',
  'vikrantsavaratkar@traya.health',
  'fazalmurtuza@traya.health',
];

export const canDownloadStoreVisitLogs = getCurrentUserRole() === ROLES_NAME.SUPER_ADMIN
  || STORE_VISIT_DOWNLOAD_EMAILS.includes(secureLocalStorage.getItem('email'));

export const canEditStoreVisitLogs = [ROLES_NAME.SUPER_ADMIN, ROLES_NAME.ADMIN].includes(getCurrentUserRole())
  || STORE_VISIT_DOWNLOAD_EMAILS.includes(secureLocalStorage.getItem('email'));

// IVR Type constants (moved from constants.js to break circular dependency)
export const IVR_TYPE = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
};

// Utility function to check if IVR categories and tags should be shown
export const shouldShowIVRCategories = (tag, ivr_type, is_slot_booked) => {
  if ([
    ENGAGEMENT_TAGS.IVR_BOOKING,
    ENGAGEMENT_TAGS.IVR_CALLBACK,
    ENGAGEMENT_TAGS.SLOT_BOOKING
  ].includes(tag)) return true;

  if ([IVR_TYPE.INBOUND, IVR_TYPE.OUTBOUND].includes(ivr_type)) return true;

  if (is_slot_booked && [
    ENGAGEMENT_TAGS.WEEK_1,
    ENGAGEMENT_TAGS.RETENTION_CALL,
    ENGAGEMENT_TAGS.WEEK_3,
    ENGAGEMENT_TAGS.W0_CALL
  ].includes(tag)) return true;

  return false;
};
